const $1da12facc0a277d6$export$5416796335c2f54c = ()=>{
    // the below flag is used to prevent DoubleClickManager creatives from blowing up the dom
    // using document.write. The file dcmads.js will run a regex for "4|40004007" against
    // window.dcmads.eids to decide whether it appends creative content using document.write
    // or HTMLElement.appendChild. Solves: https://t.corp.amazon.com/HEDWIGTT-300
    window.dcmads = window.dcmads || {};
    window.dcmads.eids = '4|40004007';
};


const $868ff823e8351ef6$var$HOST_SCOPE = 'sfImpression';
const $868ff823e8351ef6$var$LIGHTAD_SCOPE = 'LightAdImpression';
const $868ff823e8351ef6$var$VIEWABLE_LATENCY = 'viewablelatency';
const $868ff823e8351ef6$var$create = (csaKey, csmKey, csmMessage)=>{
    return {
        csaKey: csaKey,
        csmKey: csmKey,
        csmMessage: csmMessage
    };
};
const $868ff823e8351ef6$export$9b05386e98b32215 = $868ff823e8351ef6$var$create('bodyBegin', 'bb');
const $868ff823e8351ef6$export$8e1af8d29b2d2660 = $868ff823e8351ef6$var$create('bodyBegin', 'bb', $868ff823e8351ef6$var$HOST_SCOPE);
const $868ff823e8351ef6$export$5fa59a5707bdde1d = $868ff823e8351ef6$var$create('bodyBegin', 'bb', $868ff823e8351ef6$var$LIGHTAD_SCOPE);
const $868ff823e8351ef6$export$ddd0fb968b6370bc = $868ff823e8351ef6$var$create('bodyEnd', 'be');
const $868ff823e8351ef6$export$628e6d0c75e491fc = $868ff823e8351ef6$var$create('clickToATF', 'af');
const $868ff823e8351ef6$export$19ec01cbfbe44704 = $868ff823e8351ef6$var$create('criticalFeature', 'cf');
const $868ff823e8351ef6$export$3bd6a1dc71910852 = $868ff823e8351ef6$var$create('criticalFeature', 'cf', $868ff823e8351ef6$var$HOST_SCOPE);
const $868ff823e8351ef6$export$bc46e64406cfd832 = $868ff823e8351ef6$var$create('criticalFeature', 'cf', $868ff823e8351ef6$var$LIGHTAD_SCOPE);
const $868ff823e8351ef6$export$4c02edeb1b5e410a = $868ff823e8351ef6$var$create('loaded', 'ld');
const $868ff823e8351ef6$export$abd3b2c5ae6ac709 = $868ff823e8351ef6$var$create('loaded', 'ld', $868ff823e8351ef6$var$HOST_SCOPE);
const $868ff823e8351ef6$export$ab8ab33796b9d601 = $868ff823e8351ef6$var$create('loaded', 'ld', $868ff823e8351ef6$var$LIGHTAD_SCOPE);
const $868ff823e8351ef6$export$b5fe6b2464b1ad0c = $868ff823e8351ef6$var$create('viewablelatency:bodyBegin', 'bb', $868ff823e8351ef6$var$VIEWABLE_LATENCY);
const $868ff823e8351ef6$export$dd2d5c51c14e6ad7 = $868ff823e8351ef6$var$create('viewablelatency:loaded', 'ld', $868ff823e8351ef6$var$VIEWABLE_LATENCY);


const $b3a71d4461d0cfe8$export$7b0ce1a6e0e55f7a = ()=>{
    Object.defineProperty(Document.prototype, 'cookie', {
        get: ()=>'',
        set: ()=>{
        // Empty
        }
    });
};
const $b3a71d4461d0cfe8$export$a61d9e10c3bd524f = ()=>{
    var _window_navigator, _window;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_navigator = _window.navigator) === null || _window_navigator === void 0 ? void 0 : _window_navigator.geolocation) {
        window.navigator.geolocation.watchPosition = (_successCallback, _errorCallback, _options)=>{
            return 0; // Empty
        };
        window.navigator.geolocation.getCurrentPosition = (_successCallback, _errorCallback, _options)=>{
        // Empty
        };
    }
};
const $b3a71d4461d0cfe8$export$e4adf93fa9694f6 = (msg, ex)=>{
    /* eslint-disable no-console */ console.error(msg, ex);
/* eslint-enable no-console */ };
const $b3a71d4461d0cfe8$export$1dbacc10782d79ff = (c)=>{
    c.sendLatencyMetric((0, $868ff823e8351ef6$export$4c02edeb1b5e410a));
    c.sendLatencyMetric((0, $868ff823e8351ef6$export$19ec01cbfbe44704));
};


const $cdfa235a5a79407b$export$ff1e03425229fa2c = 'sf iframe ready';


/*
 * All Error logging should go through these 2 functions.
 * Issues which degrade customer experience should call {@link logFatal}
 * Log level descriptions: https://w.amazon.com/bin/view/ClientSideMetrics/UserDocs/JavascriptErrors/#Error_levels
 * This will send messages/errors to RTLA, which can be analyzed to provide more information.
 */ /**
 * Logs a message to the console, with console.debug(message)
 * @param message text send to console
 */ var $b57dd1b6deb577cc$export$4cdc8edb1e3c510c = function(message) {
    console.debug(message);
};
var $b57dd1b6deb577cc$export$cc36178e946876e8 = function(message, err) {
    console.warn(message, JSON.stringify(err));
    $b57dd1b6deb577cc$var$emitToRTLA('WARN', message, $b57dd1b6deb577cc$var$toError(message, err));
};
var $b57dd1b6deb577cc$export$58da9968c3170cb1 = function(message, err) {
    console.error(message, JSON.stringify(err));
    $b57dd1b6deb577cc$var$emitToRTLA('ERROR', message, $b57dd1b6deb577cc$var$toError(message, err));
};
var $b57dd1b6deb577cc$export$278222a831e222e9 = function(message, err) {
    console.error(message, JSON.stringify(err));
    $b57dd1b6deb577cc$var$emitToRTLA('FATAL', message, $b57dd1b6deb577cc$var$toError(message, err));
};
var $b57dd1b6deb577cc$var$emitToRTLA = function(level, message, err) {
    var _a;
    (_a = window.ueLogError) === null || _a === void 0 || _a.call(window, err, {
        logLevel: level,
        attribution: 'APE-safeframe',
        message: message + ' | '
    });
};
var $b57dd1b6deb577cc$var$toError = function(message, err) {
    return err instanceof Error ? err : err ? new Error(err) : new Error(message);
};



// Must be kept in sync with https://tiny.amazon.com/2xu3ne6j/SafeframeCSP
const $278476fd5b62a476$var$allowedReferrers = [
    'amazon.com',
    'amazon.in',
    'amazon.de',
    'amazon.co.jp',
    'amazon.co.uk',
    'amazon.ca',
    'amazon.com.au',
    'amazon.com.be',
    'amazon.com.br',
    'amazon.com.mx',
    'amazon.com.tr',
    'amazon.eg',
    'amazon.es',
    'amazon.fr',
    'amazon.it',
    'amazon.nl',
    'amazon.pl',
    'amazon.sa',
    'amazon.se',
    'amazon.sg',
    'amazon.ae',
    'amazon.co.za',
    'amazon.cn',
    'amazon.dev',
    'boxofficemojo.com',
    'a2z.com',
    'console.harmony.a2z.com',
    'depot.advertising.amazon.dev',
    'harmony.a2z.com',
    'd116tmsy8qpy37.cloudfront.net',
    'd1u3onhraow3iz.cloudfront.net',
    'd1ubtmbgqm1jlf.cloudfront.net',
    'd2dk40qqpfbxei.cloudfront.net',
    'd2jbcalcdp0p85.cloudfront.net',
    'd2y0vsnh7zmbrq.cloudfront.net',
    'd345aeerog89iv.cloudfront.net',
    'imdb.com'
];
const $278476fd5b62a476$var$isMatched = (referrerHostName, allowedList)=>{
    return allowedList.some((domain)=>{
        return referrerHostName.endsWith(domain);
    });
};
const $278476fd5b62a476$export$3338c8be5e6eacef = ()=>{
    const referrer = document.referrer;
    if (!referrer) return false; // No referrer means it's not allowed
    try {
        const url = new URL(referrer);
        return $278476fd5b62a476$var$isMatched(url.hostname, $278476fd5b62a476$var$allowedReferrers);
    } catch (error) {
        (0, $b57dd1b6deb577cc$export$58da9968c3170cb1)('Invalid referrer URL:', referrer);
        return false;
    }
};


let $c2b6fbe269a16f75$var$cachedPayload = null;
let $c2b6fbe269a16f75$var$cachedViewabilityStandards = null;
let $c2b6fbe269a16f75$var$cachedPlayingTime = null;
class $c2b6fbe269a16f75$var$SfViewableInfoImpl {
    /**
     * @desc [Internal & External] Gives the viewability standards of SafeFrame container
     */ viewabilityStandards() {
        $c2b6fbe269a16f75$var$cachedViewabilityStandards = $c2b6fbe269a16f75$var$cachedViewabilityStandards || [];
        return $c2b6fbe269a16f75$var$cachedViewabilityStandards;
    }
    /**
     * @desc [Internal & External] Gives the viewability payload of SafeFrame container
     * @returns {Object} ViewabilityPayload - cachedPayload
     */ payload() {
        // TODO Fix this incosistency
        $c2b6fbe269a16f75$var$cachedPayload = $c2b6fbe269a16f75$var$cachedPayload || {}; //This is probably a bug
        return $c2b6fbe269a16f75$var$cachedPayload;
    }
}
const $c2b6fbe269a16f75$export$cd27f9a52b1f8e44 = new $c2b6fbe269a16f75$var$SfViewableInfoImpl();
/**
 * @desc Gives the playing time in seconds for a video creative
 * @returns {Number} cachedPlayingTime
 */ const $c2b6fbe269a16f75$var$$sfPlayingTimeInfo = {
    playingTime: ()=>{
        $c2b6fbe269a16f75$var$cachedPlayingTime = $c2b6fbe269a16f75$var$cachedPlayingTime || 0;
        return $c2b6fbe269a16f75$var$cachedPlayingTime;
    }
};
const $c2b6fbe269a16f75$export$e4936ec1fd020a06 = ()=>{
    return $c2b6fbe269a16f75$export$cd27f9a52b1f8e44;
};
const $c2b6fbe269a16f75$export$cadfdfaff71363e = ()=>{
    return $c2b6fbe269a16f75$var$$sfPlayingTimeInfo;
};
const $c2b6fbe269a16f75$export$722fbec263ad908a = (data)=>{
    $c2b6fbe269a16f75$var$cachedPayload = (data === null || data === void 0 ? void 0 : data.payload) !== undefined ? data === null || data === void 0 ? void 0 : data.payload : null;
    if ($c2b6fbe269a16f75$var$cachedPayload === null) // Problem determining payload remove functions that expose it
    delete $c2b6fbe269a16f75$export$cd27f9a52b1f8e44.payload;
    $c2b6fbe269a16f75$var$cachedViewabilityStandards = (data === null || data === void 0 ? void 0 : data.viewabilityStandards) !== undefined ? data === null || data === void 0 ? void 0 : data.viewabilityStandards : null;
    if ($c2b6fbe269a16f75$var$cachedViewabilityStandards === null) // Problem determining viewabilityStandards remove functions that expose it
    delete $c2b6fbe269a16f75$export$cd27f9a52b1f8e44.viewabilityStandards;
};
const $c2b6fbe269a16f75$export$a2ff20089055e79d = (playingTime)=>{
    $c2b6fbe269a16f75$var$cachedPlayingTime = playingTime;
    if ($c2b6fbe269a16f75$var$cachedPlayingTime === null) // Problem determining playingTime remove functions that expose it
    delete $c2b6fbe269a16f75$var$$sfPlayingTimeInfo.playingTime;
};



// List of Pre-Defined CSA Counters to be used inside the safeframe.
const $7b4b43381f421ea5$export$e82123d0c5506f35 = 'adload_iframeinitialized';
const $7b4b43381f421ea5$export$672257010af09af1 = 'adload_renderstart';
const $7b4b43381f421ea5$export$b4f76538e9c39ff7 = 'adload_renderend';
const $7b4b43381f421ea5$export$9adddded674603db = 'adload_creativewritten';
const $7b4b43381f421ea5$export$b36069fbb5a2a2c0 = 'impression';
const $7b4b43381f421ea5$export$2df3159743a97555 = 'btr';
const $7b4b43381f421ea5$export$1bfab9bd7bf483b1 = 'unservedimpression';
const $7b4b43381f421ea5$export$301d9ea199f62436 = 'viewability';
const $7b4b43381f421ea5$export$a3d20722382a3045 = 'unservedviewability';
const $7b4b43381f421ea5$export$41443bf3b9ff42f9 = 'measurability';
const $7b4b43381f421ea5$export$21c466265830bc3a = 'adload_start';
const $7b4b43381f421ea5$export$578a4c3d73a6d794 = 'adload_delayload';


// List of Pre-Defined CSM Counters to be used inside the safeframe.
const $1ed025fb74d72694$export$e82123d0c5506f35 = 'adload:iframeinitialized';
const $1ed025fb74d72694$export$672257010af09af1 = 'adload:renderstart';
const $1ed025fb74d72694$export$b4f76538e9c39ff7 = 'adload:renderend';
const $1ed025fb74d72694$export$9adddded674603db = 'adload:creativewritten';
const $1ed025fb74d72694$export$b36069fbb5a2a2c0 = 'adload:impression';
const $1ed025fb74d72694$export$2df3159743a97555 = 'adload:btr';
const $1ed025fb74d72694$export$1bfab9bd7bf483b1 = 'adload:unservedimpression';
const $1ed025fb74d72694$export$301d9ea199f62436 = 'adload:viewability';
const $1ed025fb74d72694$export$a3d20722382a3045 = 'adload:unservedviewability';
const $1ed025fb74d72694$export$41443bf3b9ff42f9 = 'adload:measurability';
const $1ed025fb74d72694$export$21c466265830bc3a = 'adload:start';
const $1ed025fb74d72694$export$578a4c3d73a6d794 = 'adload:delayloadcallback';
const $1ed025fb74d72694$export$8b9f384f86776ac0 = 'adload:iframecreated';



const $f5371cfcc04ab4e3$export$1ae48495250e70c1 = (weblabsWindow, prefix)=>{
    const weblabTreatment = ()=>{
        var _weblabsWindow_renderingWeblabs_prefix, _weblabsWindow_renderingWeblabs;
        return weblabsWindow === null || weblabsWindow === void 0 ? void 0 : (_weblabsWindow_renderingWeblabs = weblabsWindow.renderingWeblabs) === null || _weblabsWindow_renderingWeblabs === void 0 ? void 0 : (_weblabsWindow_renderingWeblabs_prefix = _weblabsWindow_renderingWeblabs[prefix]) === null || _weblabsWindow_renderingWeblabs_prefix === void 0 ? void 0 : _weblabsWindow_renderingWeblabs_prefix.toLowerCase();
    };
    return {
        isT1 () {
            return weblabTreatment() === 't1';
        }
    };
};
const $f5371cfcc04ab4e3$export$65d4cd5bfb5efd99 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'A2I_HOMEPAGE_CARD_THEMING_360311');
const $f5371cfcc04ab4e3$export$b0ca8c371c8fd3bd = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'ADPT_SF_LOW_RATE_METRIC_LOGGING_1256362');
const $f5371cfcc04ab4e3$export$eb0afc859cf95bf8 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'ADPT_SF_HIGH_RATE_METRIC_LOGGING_1256364');
const $f5371cfcc04ab4e3$export$a87e2bc2a6a86c83 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'ADPT_SF_PIXEL_FIRING_1151992');
const $f5371cfcc04ab4e3$export$f6b745fabc391233 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_SERVER_SIDE_CREATIVE_SIZING_1230792');
const $f5371cfcc04ab4e3$export$7db916e80a224043 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_OBSTRUCTIONS_1237329');
const $f5371cfcc04ab4e3$export$e98c365a5851df6e = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_SIZING_1238561');
const $f5371cfcc04ab4e3$export$78d6df2054616a79 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_CONTINUOUS_OBSTRUCTION_CHECK_1246149');
const $f5371cfcc04ab4e3$export$88fbf8076ec05b = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_CLICK_TRACKING_PAINTER_TEST_1259727');
const $f5371cfcc04ab4e3$export$8be0af4ff89fab1c = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_H1_SAFEZONE_1279523');
const $f5371cfcc04ab4e3$export$1f8bd04ee7de0dc0 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_DEDUPE_SF_VIDEO_PIXELS_1279569');
const $f5371cfcc04ab4e3$export$179e693551b16536 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_DEPRECATE_CHANGESIZE_1282516');
const $f5371cfcc04ab4e3$export$413ddc762387fca = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_LIGHT_AD_DETAILS_DATA_ATTR_1282877');
const $f5371cfcc04ab4e3$export$f201cea58945cab5 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_ONERROR_COLLAPSE_1285300');
const $f5371cfcc04ab4e3$export$d3cb3e0b348d5258 = ()=>$f5371cfcc04ab4e3$export$1ae48495250e70c1(window, 'APM_STORES_JPS_JRS_SAFEFRAME_DOCUMENT_WRITE_1286180');


/**
 * measurementMethod will be an enum used for reporting purposes with following possible values
 *  * btr_client
 *  * btr_server
 *  * cod_client
 *  * cod_server
 *  * coi_client
 *  * coi_server
 *  * unknown (default option)
 * cod = Count on download: Creative html/script/tag/assets are requested by the client device.
 * coi = Count on Insertion: Represents counting at time of won bid / ad serve prior to download request by client.
 * btr = Begin to render: Creative assets are loaded and begin to render
 *
 */ const $0aca3b7155cd1ec6$export$d8b8f22c20d3745b = 'btr_client';
const $0aca3b7155cd1ec6$export$8cd9fc9636beb7a1 = 'cod_client';


const $149045d10d157dc3$export$f671200c878b4862 = (handler, errorHandler, errorMessage)=>{
    return (...args)=>{
        try {
            handler(...args);
        } catch (ex) {
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorMessage ? errorMessage : 'Error in handler', ex);
        }
    };
};
const $149045d10d157dc3$export$ac5608bbe92d6fdc = (mediaType)=>mediaType === 'V';
const $149045d10d157dc3$export$867e660d90f641b0 = (base64)=>$149045d10d157dc3$var$b64_to_utf8(base64);
const $149045d10d157dc3$export$f1965066b3b18a6d = (js_text)=>$149045d10d157dc3$var$utf8_to_b64(js_text);
const $149045d10d157dc3$var$base64TestRegexp = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
/**
 * @deprecated Remove once GPAT changes that only send text have been rolled out
 */ const $149045d10d157dc3$var$isBase64 = (stringToTest)=>$149045d10d157dc3$var$base64TestRegexp.test(stringToTest);
const $149045d10d157dc3$export$f65d427d70ef5760 = (stringToTest)=>$149045d10d157dc3$var$isBase64(stringToTest) ? $149045d10d157dc3$export$867e660d90f641b0(stringToTest) : stringToTest;
const $149045d10d157dc3$export$1eb50be0cd76c983 = (stringToTest)=>$149045d10d157dc3$var$isBase64(stringToTest) ? stringToTest : $149045d10d157dc3$var$utf8_to_b64(stringToTest);
// We use unescape even though not recommended due to performance and code size
const $149045d10d157dc3$var$utf8_to_b64 = (utf8)=>{
    return btoa(unescape(encodeURIComponent(utf8)));
};
const $149045d10d157dc3$var$b64_to_utf8 = (base64)=>{
    return decodeURIComponent(escape(atob(base64)));
};
const $149045d10d157dc3$export$83b788b1a3698c03 = (obj)=>{
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};
const $149045d10d157dc3$export$542b30bfdebb19de = (url)=>{
    if (!url) return url;
    // eslint-disable-next-line no-template-curly-in-string
    return url.split('&c=${AAX_PAYLOAD}').join('');
};


// https://w.amazon.com/index.php/ClientSideMetrics/UserDocs/Instrumentation/Tags
var $1ff6c651acff030c$export$a0561586bffc4f49 = function(name) {
    return name.replace(/_/g, ':');
};


var $ac841af8bc571595$export$66f0346f79d21dc8 = function(tagPrefix, placement, tagSuffix) {
    if (!$ac841af8bc571595$export$b94af25553d74642()) return;
    $ac841af8bc571595$export$28f26398ce837d90($ac841af8bc571595$var$placementTag(tagPrefix, placement.id, tagSuffix));
    $ac841af8bc571595$export$28f26398ce837d90($ac841af8bc571595$var$placementTag(tagPrefix, (0, $1ff6c651acff030c$export$a0561586bffc4f49)(placement.name), tagSuffix));
};
var $ac841af8bc571595$export$74bf80bc14f25706 = function(tagPrefix, tagSuffix) {
    if (!$ac841af8bc571595$export$b94af25553d74642()) return;
    $ac841af8bc571595$export$28f26398ce837d90(tagPrefix + $ac841af8bc571595$var$getTagSuffix(tagSuffix));
};
var $ac841af8bc571595$export$b94af25553d74642 = function() {
    var _a;
    return typeof ((_a = window === null || window === void 0 ? void 0 : window.ue) === null || _a === void 0 ? void 0 : _a.tag) === 'function';
};
var $ac841af8bc571595$export$28f26398ce837d90 = function(tag) {
    var _a;
    return (_a = window === null || window === void 0 ? void 0 : window.ue) === null || _a === void 0 ? void 0 : _a.tag(tag);
};
var $ac841af8bc571595$var$placementTag = function(tagPrefix, placement, tagSuffix) {
    return "".concat(tagPrefix, ":").concat(placement).concat($ac841af8bc571595$var$getTagSuffix(tagSuffix));
};
var $ac841af8bc571595$var$getTagSuffix = function(tagSuffix) {
    return tagSuffix ? ":".concat(tagSuffix) : '';
};



var $eccd62b8246e8f2a$export$a1e0552356f3c9eb = function(entity) {
    if (!window.csa) return;
    try {
        window.csa('Events', {
            producerId: 'adplacements'
        })('setEntity', {
            adCreativeMetaData: entity
        });
    } catch (ex) {
        (0, $b57dd1b6deb577cc$export$58da9968c3170cb1)("Error with 'setEntity' CSA", ex);
    }
};
var $eccd62b8246e8f2a$export$85182658a28cf751 = function(metric, placement, count) {
    if (count === void 0) count = 1;
    if (!window.csa) return;
    try {
        window.csa('Events', {
            producerId: 'adplacements'
        })('log', {
            schemaId: 'ApeSafeframe.csaEvent.1',
            metricName: metric + ':' + placement.name + ':' + placement.id,
            metricValue: count
        }, {
            ent: 'all'
        });
    } catch (ex) {
        (0, $b57dd1b6deb577cc$export$58da9968c3170cb1)("Error with 'logCsaEvent' CSA", ex);
    }
};
var $eccd62b8246e8f2a$export$9532014759946ca0 = function(metric, count) {
    if (count === void 0) count = 1;
    if (!window.csa) return;
    try {
        window.csa('Events', {
            producerId: 'adplacements'
        })('log', {
            schemaId: 'ApeSafeframe.csaEvent.1',
            metricName: metric,
            metricValue: count
        }, {
            ent: 'all'
        });
    } catch (ex) {
        (0, $b57dd1b6deb577cc$export$58da9968c3170cb1)("Error with 'incrementCounter' CSA", ex);
    }
};


const $14a425e1552c92b7$export$e6b6b29302f715dd = (placement, lightAdDetails)=>{
    (0, $ac841af8bc571595$export$66f0346f79d21dc8)('adrender', placement);
    (0, $ac841af8bc571595$export$66f0346f79d21dc8)('adrender:lightad', placement);
    if (lightAdDetails.adCreativeMetaData.adCreativeId) {
        (0, $ac841af8bc571595$export$66f0346f79d21dc8)('adrender', placement, `creativeid:${lightAdDetails.adCreativeMetaData.adCreativeId}`);
        (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
            creativeId: lightAdDetails.adCreativeMetaData.adCreativeId.toString()
        });
    }
    if (lightAdDetails.adCreativeMetaData.adProgramId) {
        (0, $ac841af8bc571595$export$66f0346f79d21dc8)('adrender', placement, `programid:${lightAdDetails.adCreativeMetaData.adProgramId}`);
        (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
            programId: lightAdDetails.adCreativeMetaData.adProgramId.toString()
        });
    }
    if (typeof lightAdDetails.isCardsFlow !== 'undefined') (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
        isCardsFlow: lightAdDetails.isCardsFlow.toString()
    });
    const creativeTemplateName = $14a425e1552c92b7$export$330918963d7ab972(lightAdDetails);
    (0, $ac841af8bc571595$export$66f0346f79d21dc8)('adrender', placement, `creativetemplatename:${creativeTemplateName}`);
    (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
        adrender: 'true',
        creativeTemplateName: creativeTemplateName,
        isLightAds: 'true'
    });
};
const $14a425e1552c92b7$export$5e9f7b56e2ea117f = (adDetails)=>{
    if (!(adDetails === null || adDetails === void 0 ? void 0 : adDetails.adCreativeMetaData) || !Object.keys(adDetails.adCreativeMetaData).length) {
        (0, $ac841af8bc571595$export$74bf80bc14f25706)('noadrender');
        (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
            adrender: 'false'
        });
        return;
    }
    (0, $ac841af8bc571595$export$74bf80bc14f25706)('adrender');
    (0, $ac841af8bc571595$export$74bf80bc14f25706)('adrender:safeframe');
    $14a425e1552c92b7$var$tagTemplate(adDetails);
    $14a425e1552c92b7$var$tagCreativeId(adDetails);
    $14a425e1552c92b7$var$tagProgramId(adDetails);
    $14a425e1552c92b7$var$tagIsCardsFlow(adDetails);
};
const $14a425e1552c92b7$var$tagTemplate = (adDetails)=>{
    const creativeTemplateName = $14a425e1552c92b7$export$330918963d7ab972(adDetails);
    (0, $ac841af8bc571595$export$74bf80bc14f25706)('adrender', 'creativetemplatename:' + creativeTemplateName);
    (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
        adrender: 'true',
        creativeTemplateName: creativeTemplateName,
        isLightAds: 'false'
    });
};
const $14a425e1552c92b7$export$330918963d7ab972 = (adDetails)=>{
    if (adDetails.adCreativeMetaData.adCreativeTemplateName) return adDetails.adCreativeMetaData.adCreativeTemplateName.toLowerCase().replace(/[^0-9a-z]/g, '');
    return 'unknown';
};
const $14a425e1552c92b7$var$tagCreativeId = (adDetails)=>{
    if (adDetails.adCreativeMetaData.adCreativeId) {
        (0, $ac841af8bc571595$export$74bf80bc14f25706)('adrender', 'creativeid:' + adDetails.adCreativeMetaData.adCreativeId);
        (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
            creativeId: adDetails.adCreativeMetaData.adCreativeId
        });
    }
};
const $14a425e1552c92b7$var$tagProgramId = (adDetails)=>{
    if (adDetails.adCreativeMetaData.adProgramId) {
        (0, $ac841af8bc571595$export$74bf80bc14f25706)('adrender', 'programid:' + adDetails.adCreativeMetaData.adProgramId);
        (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
            adProgramId: adDetails.adCreativeMetaData.adProgramId
        });
    }
};
const $14a425e1552c92b7$var$tagIsCardsFlow = (adDetails)=>{
    if (adDetails.isCardsFlow !== undefined) (0, $eccd62b8246e8f2a$export$a1e0552356f3c9eb)({
        isCardsFlow: adDetails.isCardsFlow.toString()
    });
};


const $338691c168a56155$var$EMPTY_OBJECT_STRINGIFIED = '{}';
const $338691c168a56155$var$EMPTY_STRING = '';
const $338691c168a56155$export$c5b025df2a549474 = (url, queryParamKey, // eslint-disable-next-line @typescript-eslint/no-explicit-any
queryParamValueObject)=>{
    if (queryParamKey === $338691c168a56155$var$EMPTY_STRING) throw new Error('Invalid queryParamKey input to addJSONQueryParamToURL: ' + JSON.stringify({
        queryParamKey: queryParamKey
    }));
    const urlObject = new URL(url);
    const pk = urlObject.searchParams.get(queryParamKey);
    const existingJSONString = pk ? pk : $338691c168a56155$var$EMPTY_OBJECT_STRINGIFIED;
    const existingJSONObject = JSON.parse(existingJSONString);
    const mergedJSONObject = Object.assign(existingJSONObject, queryParamValueObject);
    urlObject.searchParams.set(queryParamKey, JSON.stringify(mergedJSONObject));
    return urlObject.toString();
};


/*
 * We no longer trigger pixel tracking URLs by appending the img to the DOM.
 * We use a made up attribute 'pixel-url' to store the URL for testing/debugging.
 * We will directly call the pixel URL with the fetch API.
 */ const $dc7c4b01142d1fbe$export$1997669149ef0084 = (id, pixelUrl)=>{
    const pixel = document.createElement('img');
    pixel.id = id;
    pixel.style.display = 'none';
    pixel.setAttribute('pixel-url', pixelUrl);
    return pixel;
};
const $dc7c4b01142d1fbe$export$cdd3af06cfe23b64 = (baseCounterName, eventName, extension)=>{
    let finalCounter = baseCounterName + eventName;
    if (extension) finalCounter += '_' + extension;
    return finalCounter;
};
const $dc7c4b01142d1fbe$export$46108506ae1da288 = (id)=>!!document.getElementById(id);
const $dc7c4b01142d1fbe$export$724d3435fa6261af = async (c, { pixelUrl: pixelUrl, id: id, baseCounterName: baseCounterName, baseMetricName: baseMetricName, counterExtension: counterExtension, logId: logId, aaxProgramId: aaxProgramId })=>{
    try {
        if ($dc7c4b01142d1fbe$export$46108506ae1da288(id)) return false;
        c.logCsaEvent($dc7c4b01142d1fbe$export$cdd3af06cfe23b64(baseMetricName, 'fired', counterExtension));
        c.countMetric($dc7c4b01142d1fbe$export$cdd3af06cfe23b64(baseCounterName, 'fired', counterExtension), 1);
        await fetch(pixelUrl, {
            keepalive: true,
            mode: 'no-cors',
            priority: 'low'
        });
        document.getElementsByTagName('body')[0].appendChild($dc7c4b01142d1fbe$export$1997669149ef0084(id, pixelUrl));
        c.countMetric($dc7c4b01142d1fbe$export$cdd3af06cfe23b64(baseCounterName, 'loaded', counterExtension), 1);
        c.logCsaEvent($dc7c4b01142d1fbe$export$cdd3af06cfe23b64(baseMetricName, 'loaded', counterExtension));
        c.countMetric(`pixel:${logId}`, 1, true);
        aaxProgramId && c.countMetric(`pixel:${logId}:${aaxProgramId}`, 1, true);
        return true;
    } catch (ex) {
        c.countMetric($dc7c4b01142d1fbe$export$cdd3af06cfe23b64(baseCounterName, 'error', counterExtension), 1);
        c.logCsaEvent($dc7c4b01142d1fbe$export$cdd3af06cfe23b64(baseMetricName, 'error', counterExtension));
        c.logError(`Error firing pixels: ${pixelUrl}`, ex);
        throw ex;
    }
};
const $dc7c4b01142d1fbe$export$4df4b6f5ebb26df1 = (baseUrl, ext, params)=>{
    // TODO: This is not fault tolerant, relies on correct format of '/'
    return baseUrl + ext + JSON.stringify(params);
};


const $73e0ca2ae6c1f0f4$export$c5d6c621c7de1d76 = 'impressionFired';


const $1a3344c5a716a1e2$export$4c02edeb1b5e410a = 'btr:loaded';
const $1a3344c5a716a1e2$export$103bedf43ba882db = 'btr:error';
const $1a3344c5a716a1e2$export$d0f1ac80e09a5d7c = 'btr:impression';
const $1a3344c5a716a1e2$export$e2752c96dbc2a6eb = 'btr:noimages';
const $1a3344c5a716a1e2$export$63c60b2043098f80 = 'btr:nourl';
const $1a3344c5a716a1e2$export$5ea3c5a4d464f920 = 'btr:taggedcreative';


const $9b9b877803d7c3a9$export$4c02edeb1b5e410a = 'cod:loaded';
const $9b9b877803d7c3a9$export$103bedf43ba882db = 'cod:error';
const $9b9b877803d7c3a9$export$d0f1ac80e09a5d7c = 'cod:impression';
const $9b9b877803d7c3a9$export$e2752c96dbc2a6eb = 'cod:noimages';
const $9b9b877803d7c3a9$export$5ea3c5a4d464f920 = 'cod:taggedcreative';




const $7c25552237c44df8$export$2dd88f2512258573 = {
    VIEWABLE: 'viewable',
    NOT_VIEWABLE: 'not_viewable'
};
class $7c25552237c44df8$export$db4688a8b7035751 {
    constructor(){
        /**
         * @private {Number} _viewableStartTimeInMilliseconds - time when the
         *   most recent transition from not viewable to viewable state occurred
         */ this._viewableStartTimeInMilliseconds = undefined;
        /**
         * @private {String} _currentState - the most recent state that was transitioned to
         */ this._currentState = $7c25552237c44df8$export$2dd88f2512258573.NOT_VIEWABLE;
        this._isCurrentlyInNotViewableState = ()=>{
            return this._currentState === $7c25552237c44df8$export$2dd88f2512258573.NOT_VIEWABLE;
        };
        /**
         * @method transitionToViewableState
         * @desc [Internal] informs object to transition to the viewable state
         * @param {Number} currentTimeInMilliseconds
         */ this.transitionToViewableState = (currentTimeInMilliseconds)=>{
            /**
             * @method _isCurrentlyInNotViewableState
             * @desc [Internal] checks if object is in the not_viewable state
             * @private
             */ if (this._isCurrentlyInNotViewableState()) this._viewableStartTimeInMilliseconds = currentTimeInMilliseconds;
            this._currentState = $7c25552237c44df8$export$2dd88f2512258573.VIEWABLE;
        };
        /**
         * @method transitionToNotViewableState
         * @desc [Internal] informs object to transition to the not_viewable state
         */ this.transitionToNotViewableState = ()=>{
            this._currentState = $7c25552237c44df8$export$2dd88f2512258573.NOT_VIEWABLE;
        };
        /**
         * @method getViewableTimeInSeconds
         * @desc [Internal] Returns the amount of time that creative has been viewable according to a viewability standard
         * @param {Number} currentTimeInMilliseconds
         */ this.getViewableTimeInSeconds = (currentTimeInMilliseconds)=>{
            if (this._isCurrentlyInNotViewableState() || typeof this._viewableStartTimeInMilliseconds === 'undefined') return 0;
            return (currentTimeInMilliseconds - this._viewableStartTimeInMilliseconds) / 1000;
        };
    }
}


/**
 * Evaluates whether a creative inside the provided container has begun to render.
 * This is determined by checking if any visible images within the container have loaded.
 *
 * @param creativeContainer - The HTML element containing the creative.
 * @returns A response indicating whether rendering has begun.
 */ var $c9ce6323b43f3e14$export$6d47de433179ae29 = function(creativeContainer) {
    var images = Array.from(creativeContainer.querySelectorAll('img')).filter(function(x) {
        return getComputedStyle(x).display !== 'none';
    });
    return $c9ce6323b43f3e14$var$evaluateAnyImageLoaded(images);
};
/**
 * Evaluates whether any image in the provided list has successfully loaded.
 *
 * The function checks if at least one image is fully loaded (i.e., it is marked as complete
 * and has non-zero dimensions). If no images are present, it returns `NO_CREATIVE`.
 * If at least one image loads successfully, it returns `BEGIN_TO_RENDER`.
 * If all images fail to load, it returns `ERROR`.
 *
 * @param images - An array of HTML image elements to evaluate.
 * @returns A response indicating whether rendering has begun, no creative was found, or an error occurred.
 */ var $c9ce6323b43f3e14$var$evaluateAnyImageLoaded = function(images) {
    if (images.length === 0) return {
        success: false,
        code: 'NO_CREATIVE'
    };
    return images.some(function(img) {
        return img.complete && img.naturalWidth > 0 && img.naturalHeight > 0;
    }) ? {
        success: true,
        code: 'BEGIN_TO_RENDER'
    } : {
        success: false,
        code: 'ERROR'
    };
};



const $c8d8a5ed5d178ad5$export$a50734292ed0de40 = 'atf';
const $c8d8a5ed5d178ad5$export$e03c8382bab51532 = 'pj';
const $c8d8a5ed5d178ad5$export$3d1654c79f449afd = 'c';
const $c8d8a5ed5d178ad5$export$56f940691cae8cd9 = ({ abpAcceptable: abpAcceptable = 'false', abpStatus: abpStatus = '-1' })=>abpAcceptable === 'true' && (abpStatus === '1' || abpStatus === '-1');


class $35ecde54ed03004d$export$50627d05c9061249 {
    emitImpressionPixelMetrics(isBtrPixel) {
        const adProgramId = this.o.adCreativeMetaData.adProgramId ? this.o.adCreativeMetaData.adProgramId : 'unknown';
        const creativeTemplateNameForMetrics = (0, $14a425e1552c92b7$export$330918963d7ab972)(this.o);
        this.c.countMetric((0, $73e0ca2ae6c1f0f4$export$c5d6c621c7de1d76), 1, true);
        this.c.countMetric((0, $73e0ca2ae6c1f0f4$export$c5d6c621c7de1d76) + ':program:' + adProgramId, 1, true);
        this.c.countMetric((0, $73e0ca2ae6c1f0f4$export$c5d6c621c7de1d76) + ':template:' + creativeTemplateNameForMetrics, 1, true);
        const impressionMetric = isBtrPixel ? (0, $1a3344c5a716a1e2$export$d0f1ac80e09a5d7c) : (0, $9b9b877803d7c3a9$export$d0f1ac80e09a5d7c);
        this.c.countMetric(impressionMetric, 1, false);
        this.c.countMetric(impressionMetric, 1, true);
        this.c.countMetric(impressionMetric + ':program:' + adProgramId, 1, true);
        this.c.countMetric(impressionMetric + ':template:' + creativeTemplateNameForMetrics, 1, true);
    }
    constructor(c, o){
        this.c = c;
        this.o = o;
        // Viewability flags
        this.viewedPixels = {};
        /**
         * Tracks the amount of time a creative been considered viewable by viewability definitions.
         * Each key is a viewability definition - e.g. 'iab'
         */ this.viewableTimeCalculators = {};
        this.fireCodImpressionPixel = async ()=>{
            let isPixelFired = false;
            isPixelFired = await (0, $dc7c4b01142d1fbe$export$724d3435fa6261af)(this.c, {
                id: 'ape_impression',
                pixelUrl: $35ecde54ed03004d$export$88592af767b75a3b(this.o.aaxImpPixelUrl, (0, $c8d8a5ed5d178ad5$export$e03c8382bab51532), (0, $0aca3b7155cd1ec6$export$8cd9fc9636beb7a1)),
                baseCounterName: (0, $1ed025fb74d72694$export$b36069fbb5a2a2c0),
                baseMetricName: $7b4b43381f421ea5$export$b36069fbb5a2a2c0,
                logId: 'imp:cod',
                aaxProgramId: this.o.adCreativeMetaData.adProgramId
            });
            if (isPixelFired) // TODO: Migrate these metrics to the new pixel standard
            // https://code.amazon.com/packages/D16GSafeFrame/blobs/544913ede51c527b81aff887c5744915092be10e/--/packages/@amzn/d16gsafeframe/src/js/components/pixels/btrPixel.ts#L9
            this.emitImpressionPixelMetrics(false);
        };
        /**
         * @desc [Internal] Checks if viewable info for a video creative meets viewability standards,
         *   and if so fires viewability pixels
         * @param cachedViewability - The percentage of a creative that is currently in the viewport
         * @param viewableInfo
         * @param viewabilityStandards - Each standard must be met before its
         *   corresponding viewability pixel can be fired
         * @param isNoInventory - Indicates whether any ad was returned or not
         * @param playingTimeInSeconds - video playing time without user-initiated interruptions
         */ this.fireViewablePixelsForVideo = (cachedViewability, viewableInfo, viewabilityStandards, isNoInventory, playingTimeInSeconds)=>{
            if ((0, $149045d10d157dc3$export$83b788b1a3698c03)(this.o) || (0, $149045d10d157dc3$export$83b788b1a3698c03)(this.c) || !this.o.aaxInstrPixelUrl || !viewabilityStandards) return;
            const meetsViewabilityStandard = (viewableTime, playingTime, viewabilityStandard)=>{
                const meetsViewableTimeRequirement = viewableTime >= viewabilityStandard.t;
                const meetsPlayingTimeRequirement = playingTime && playingTime >= viewabilityStandard.t;
                return meetsViewableTimeRequirement && meetsPlayingTimeRequirement;
            };
            const fireViewablePixel = (v)=>{
                viewableInfo.v = v;
                const ps = window.aPageStart;
                const as = window.adStartTime;
                viewableInfo.ptv = ps ? (Date.now() - ps) / 1000 : 0;
                viewableInfo.ttv = as ? (Date.now() - as) / 1000 : 0;
                if (isNoInventory) viewableInfo.niv = true;
                let pixelUrl;
                if (!isNoInventory) {
                    pixelUrl = (0, $dc7c4b01142d1fbe$export$4df4b6f5ebb26df1)(this.o.aaxInstrPixelUrl, 'v/', viewableInfo);
                    (0, $dc7c4b01142d1fbe$export$724d3435fa6261af)(this.c, {
                        id: "ape_viewability_" + v.def,
                        pixelUrl: pixelUrl,
                        baseCounterName: (0, $1ed025fb74d72694$export$301d9ea199f62436),
                        baseMetricName: $7b4b43381f421ea5$export$301d9ea199f62436,
                        counterExtension: v.def,
                        logId: `view:${v.def}`,
                        aaxProgramId: this.o.adCreativeMetaData.adProgramId
                    });
                } else {
                    pixelUrl = (0, $dc7c4b01142d1fbe$export$4df4b6f5ebb26df1)(this.o.aaxInstrPixelUrl, 'niv/', viewableInfo);
                    (0, $dc7c4b01142d1fbe$export$724d3435fa6261af)(this.c, {
                        id: "ape_ni_viewability_" + v.def,
                        pixelUrl: pixelUrl,
                        baseCounterName: (0, $1ed025fb74d72694$export$a3d20722382a3045),
                        baseMetricName: $7b4b43381f421ea5$export$a3d20722382a3045,
                        counterExtension: v.def,
                        logId: 'view:niv',
                        aaxProgramId: this.o.adCreativeMetaData.adProgramId
                    });
                }
            };
            const measureViewability = (viewabilityStandard, viewablePercentage)=>{
                const def = viewabilityStandard.def;
                if (viewablePercentage && $35ecde54ed03004d$var$isViewable(viewablePercentage, viewabilityStandard.p)) this.viewableTimeCalculators[def].transitionToViewableState(Date.now());
                else this.viewableTimeCalculators[def].transitionToNotViewableState();
                const viewableTimeInSeconds = this.viewableTimeCalculators[def].getViewableTimeInSeconds(Date.now());
                const shouldFire = !this.viewedPixels[def].viewed && meetsViewabilityStandard(viewableTimeInSeconds, playingTimeInSeconds, viewabilityStandard);
                if (shouldFire) {
                    this.viewedPixels[def].viewed = true;
                    fireViewablePixel(viewabilityStandard);
                }
            };
            for(let i = 0; i < viewabilityStandards.length; i++){
                const def = viewabilityStandards[i].def;
                if (def) {
                    this.viewedPixels[def] = this.viewedPixels[def] || {};
                    this.viewedPixels[def].viewed = typeof this.viewedPixels[def].viewed === 'undefined' ? false : this.viewedPixels[def].viewed;
                    if (typeof this.viewableTimeCalculators[def] === 'undefined') this.viewableTimeCalculators[def] = new (0, $7c25552237c44df8$export$db4688a8b7035751)();
                }
            }
            // Fire pixels following this standard: https://w.amazon.com/index.php/A9/AAX/Specifications/AAXLogFormatV2_0#Pixel_View_Payload_Log
            for(let i = 0; i < viewabilityStandards.length; i++)measureViewability(viewabilityStandards[i], cachedViewability);
        };
        /**
         * @method fireViewablePixels
         * @desc [Internal] Checks if viewable info for a non-video creative meets viewability standards,
         *   and if so fires viewability pixels
         * @param {Number} cachedViewability - The percentage of a creative that is currently in the viewport
         * @param {Object} viewableInfo
         * @param {Array.<ViewabilityStandard>} viewabilityStandards - Each standard must be met before its
         *   corresponding viewability pixel can be fired
         * @param {Boolean} isNoInventory - Indicates whether any ad was returned or not
         * @param {Date} renderCompleteTime - The date to use for render time completion. Use this to calculate
         */ this.fireViewablePixels = (cachedViewability, viewableInfo, viewabilityStandards, isNoInventory)=>{
            const fireViewablePixel = (v)=>{
                viewableInfo.v = v;
                const ps = window.aPageStart;
                const as = window.adStartTime;
                viewableInfo.ptv = ps ? (Date.now() - ps) / 1000 : 0;
                viewableInfo.ttv = as ? (Date.now() - as) / 1000 : 0;
                if (isNoInventory) viewableInfo.niv = true;
                let pixelUrl;
                if (!isNoInventory) {
                    pixelUrl = (0, $dc7c4b01142d1fbe$export$4df4b6f5ebb26df1)(this.o.aaxInstrPixelUrl, 'v/', viewableInfo);
                    (0, $dc7c4b01142d1fbe$export$724d3435fa6261af)(this.c, {
                        id: "ape_viewability_" + v.def,
                        pixelUrl: pixelUrl,
                        baseCounterName: (0, $1ed025fb74d72694$export$301d9ea199f62436),
                        baseMetricName: $7b4b43381f421ea5$export$301d9ea199f62436,
                        counterExtension: v.def,
                        logId: `view:${v.def}`,
                        aaxProgramId: this.o.adCreativeMetaData.adProgramId
                    });
                } else {
                    pixelUrl = (0, $dc7c4b01142d1fbe$export$4df4b6f5ebb26df1)(this.o.aaxInstrPixelUrl, 'niv/', viewableInfo);
                    (0, $dc7c4b01142d1fbe$export$724d3435fa6261af)(this.c, {
                        id: "ape_ni_viewability_" + v.def,
                        pixelUrl: pixelUrl,
                        baseCounterName: (0, $1ed025fb74d72694$export$a3d20722382a3045),
                        baseMetricName: $7b4b43381f421ea5$export$a3d20722382a3045,
                        counterExtension: v.def,
                        logId: 'view:niv',
                        aaxProgramId: this.o.adCreativeMetaData.adProgramId
                    });
                }
            };
            const measureViewability = (viewabilityStandard)=>{
                const p = viewabilityStandard.p;
                const t = viewabilityStandard.t;
                const def = viewabilityStandard.def;
                if (!this.viewedPixels[def].viewed && cachedViewability && $35ecde54ed03004d$var$isViewable(cachedViewability, p)) {
                    if (!this.viewedPixels[def].timeout) this.viewedPixels[def].timeout = setTimeout(()=>{
                        this.viewedPixels[def].viewed = true;
                        fireViewablePixel(viewabilityStandard);
                    }, 1000 * t);
                } else if (this.viewedPixels[def].timeout) {
                    clearTimeout(this.viewedPixels[def].timeout);
                    this.viewedPixels[def].timeout = null;
                }
            };
            // Fire pixels following this standard: https://w.amazon.com/index.php/A9/AAX/Specifications/AAXLogFormatV2_0#Pixel_View_Payload_Log
            for (const vs of viewabilityStandards){
                var _this_viewedPixels;
                const def = vs.def;
                if (!((_this_viewedPixels = this.viewedPixels) === null || _this_viewedPixels === void 0 ? void 0 : _this_viewedPixels[def])) this.viewedPixels[def] = {
                    viewed: false,
                    timeout: null
                };
                measureViewability(vs);
            }
        };
    }
}
// Helper method to check if ad is viewable or not and handle the edge case when p equals 0
const $35ecde54ed03004d$var$isViewable = (viewablePercentage, p)=>{
    return 100 * viewablePercentage >= p && p !== 0 || 100 * viewablePercentage > p && p === 0;
};
const $35ecde54ed03004d$export$88592af767b75a3b = (aaxImpPixelUrl, queryParamKey, measurementMethod)=>{
    const paets = aaxImpPixelUrl.includes('.paets.');
    const legacyAnswer = (0, $338691c168a56155$export$c5b025df2a549474)(aaxImpPixelUrl, queryParamKey, {
        measurementMethod: measurementMethod
    });
    return paets ? aaxImpPixelUrl : legacyAnswer;
};
const $35ecde54ed03004d$export$af480fc3cfed262b = async (element = document.body)=>{
    const btrEvaluationWaitTime = 75;
    let elapsedTime = 0;
    const intervalMs = 5;
    return new Promise((resolve)=>{
        const intervalId = setInterval(()=>{
            elapsedTime += intervalMs;
            const response = (0, $c9ce6323b43f3e14$export$6d47de433179ae29)(element);
            if (response.success) {
                clearInterval(intervalId);
                resolve((0, $0aca3b7155cd1ec6$export$d8b8f22c20d3745b));
            } else if (elapsedTime >= btrEvaluationWaitTime) {
                clearInterval(intervalId);
                resolve((0, $0aca3b7155cd1ec6$export$8cd9fc9636beb7a1));
            }
        }, intervalMs);
    });
};




/**
 * return metadata string to log in order to identify creatives/templates that may have issues
 */ const $dcd87ab86b34c9f3$export$1c6969f2c1147c01 = (adDetails)=>{
    const metadata = `ProgramId: ${adDetails.adCreativeMetaData.adProgramId}, CreativeId: ${adDetails.adCreativeMetaData.adCreativeId}, ` + `AdId: ${adDetails.adCreativeMetaData.adId}, Template: ${adDetails.adCreativeMetaData.adCreativeTemplateName}`;
    const size = $dcd87ab86b34c9f3$var$getRelativeSize(adDetails.htmlContentEncodedLength);
    return `${metadata} (html size: ${size})`;
};
/**
 * get size in relative size to avoid having high cardinality for creatives
 */ const $dcd87ab86b34c9f3$var$getRelativeSize = (contentSize)=>{
    if (contentSize === undefined) return 'N/A';
    if (contentSize === 0) return '0';
    if (contentSize <= 5000) return '0<x<=5k';
    if (contentSize <= 100000) return '5k<x<=100k';
    return '>100k';
};


const $512bd69d0cfb283b$export$8b7eff687c7ac140 = (attr)=>{
    var _document_getElementById;
    return (_document_getElementById = document.getElementById((0, $11e05b7353c22513$export$ccc0adacf1bcc957))) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute(attr, 'true');
};
const $512bd69d0cfb283b$export$1d6284e01cbd9983 = (adDetails)=>new Promise((r, reject)=>{
        const el = document.getElementById((0, $11e05b7353c22513$export$ccc0adacf1bcc957));
        if ((el === null || el === void 0 ? void 0 : el.getAttribute((0, $11e05b7353c22513$export$cd2d158d4825105d))) === 'true') r();
        else {
            document.addEventListener((0, $11e05b7353c22513$export$d626e74fdb4b63dc), ()=>{
                $512bd69d0cfb283b$export$8b7eff687c7ac140((0, $11e05b7353c22513$export$cd2d158d4825105d));
                r();
            }, {
                once: true
            });
            const reallyLongTimeoutJustToGetRTLAToGenerate = 5000;
            setTimeout(()=>{
                if ((el === null || el === void 0 ? void 0 : el.getAttribute((0, $11e05b7353c22513$export$cd2d158d4825105d))) !== 'true') reject(new Error(`Creative script replay not detected within ${reallyLongTimeoutJustToGetRTLAToGenerate} timeout. ` + `${(0, $dcd87ab86b34c9f3$export$1c6969f2c1147c01)(adDetails)}`));
            }, reallyLongTimeoutJustToGetRTLAToGenerate);
        }
    });



const $912a5c234be6a76d$export$c9bec999c692425a = (adDetails, clientApi)=>{
    const callBlankAdValidation = async ()=>{
        var _window_crv, _window;
        if (typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window_crv = _window.crv) === null || _window_crv === void 0 ? void 0 : _window_crv.detectAndReportBlankAd) === 'function') {
            clearInterval(intervalId);
            try {
                const result = await window.crv.detectAndReportBlankAd(document.body);
                if (result) {
                    clientApi.countMetric('blankadvalidation:failure', 1, true);
                    clientApi.logError(`Blank ad detected. ${(0, $dcd87ab86b34c9f3$export$1c6969f2c1147c01)(adDetails)}`);
                } else clientApi.countMetric('blankadvalidation:success', 1, true);
            } catch (err) {
                clientApi.countMetric('blankadvalidation:error', 1, true);
            }
        }
    };
    const intervalId = setInterval(callBlankAdValidation, 1000);
};


// Threshold for considering an image to be spanning the viewport (95%)
const $0712d692a57fc699$var$VIEWPORT_COVERAGE_THRESHOLD = 0.95;
// Threshold for considering text to be significant (num chars)
const $0712d692a57fc699$var$SIGNIFICANT_TEXT_THRESHOLD = 75;
// 1P image template ads generally have this class name
const $0712d692a57fc699$var$AD_BACKGROUND_IMAGE_CLASS = 'ad-background-image';
const $0712d692a57fc699$export$615da1172a4394cb = (imgElement)=>imgElement.classList.contains($0712d692a57fc699$var$AD_BACKGROUND_IMAGE_CLASS);
const $0712d692a57fc699$export$fa08084b0edccf83 = (imgWidth)=>imgWidth / window.innerWidth >= $0712d692a57fc699$var$VIEWPORT_COVERAGE_THRESHOLD;
const $0712d692a57fc699$export$aabbcbed1d3a637f = ()=>{
    var _document_documentElement_innerText;
    // get innerText and strip whitespace
    const text = ((_document_documentElement_innerText = document.documentElement.innerText) !== null && _document_documentElement_innerText !== void 0 ? _document_documentElement_innerText : '').replace(/\s/g, '');
    return text.length > $0712d692a57fc699$var$SIGNIFICANT_TEXT_THRESHOLD;
};
const $0712d692a57fc699$export$e5745c2b0bf25e17 = (images)=>images.some((image)=>image.classList.contains($0712d692a57fc699$var$AD_BACKGROUND_IMAGE_CLASS));
const $0712d692a57fc699$export$ecda876ccc2fe511 = (images)=>{
    for (const image of images){
        const rect = image.getBoundingClientRect();
        // check to see if this image covers all/most of the viewport width
        if ($0712d692a57fc699$export$fa08084b0edccf83(rect.width)) return true;
    }
    return false;
};
const $0712d692a57fc699$export$b6d72c7ec457f9a3 = ()=>{
    // Find all images in the creative
    const images = Array.from(document.querySelectorAll('img'));
    // no images in the ad means it is not an image template
    if (!images.length) return false;
    // if any image has .ad-background-class, it is an image template
    if ($0712d692a57fc699$export$e5745c2b0bf25e17(images)) return true;
    // if no large images (spans viewport width), it is not an image template
    if (!$0712d692a57fc699$export$ecda876ccc2fe511(images)) return false;
    // if the ad has a full width image, but has a lot of text, likely not an image template
    if ($0712d692a57fc699$export$aabbcbed1d3a637f()) return false;
    // all conditions met, this is likely an image-only ad
    return true;
};
const $0712d692a57fc699$export$75b587028fcddc2b = (cms)=>{
    // Check if the creative is an image-only creative
    if ($0712d692a57fc699$export$b6d72c7ec457f9a3()) // If we found a large image and no significant text
    cms.sendMessage('resizeForImageOnlyTemplate');
};


const $11e05b7353c22513$export$9da576b8d2431e13 = async (htmlContent, client, clientApi, adDetails)=>{
    // We add an event listener if needed to track when the replay is all done
    const eventFired = (0, $512bd69d0cfb283b$export$1d6284e01cbd9983)(adDetails);
    // The below conditional checks if an inline script is running AND that document has not
    // finished painting. In this case, document.write should append to the document immediately
    // below that script, as described here: https://www.oreilly.com/library/view/javascript-the-definitive/0596000480/re204.html
    // In all other cases we will replace the contents of the document with the string passed to document.write.
    if (document.currentScript !== null) {
        let currentElement = document.currentScript;
        currentElement.insertAdjacentHTML('afterend', htmlContent);
        // Scripts do not execute when added via html string. Need to replay each script after the
        // insertion point (via next sibling). If we used replayAll on the body, it would infinitely
        // loop by replaying the script which called renderHTML in the first place.
        currentElement = currentElement.nextElementSibling;
        while(currentElement !== null){
            if (currentElement.tagName === 'SCRIPT') $11e05b7353c22513$export$a9e8db3ed7a4e02(currentElement);
            else $11e05b7353c22513$export$f608cc986470dd9c(currentElement);
            currentElement = currentElement.nextElementSibling;
        }
    } else {
        $11e05b7353c22513$export$c12706c6ea5b35db(htmlContent);
        $11e05b7353c22513$var$addFinishProcessingEvent();
        $11e05b7353c22513$export$f608cc986470dd9c(document.documentElement);
    }
    client.ensureGlobals();
    await eventFired;
    await $11e05b7353c22513$export$3756c87fad410ed6();
    // We record the render complete time as when all the sync scripts have parsed.  We do this because not all scripts will have static images
    // so can't just wait until images are loaded.  This is a judgement call however since some images theoretically could load after the script.
    client.renderCompleteTime = new Date();
};
const $11e05b7353c22513$export$cd2d158d4825105d = 'iscomplete';
const $11e05b7353c22513$export$ccc0adacf1bcc957 = 'creativeReplayStatus';
const $11e05b7353c22513$export$d626e74fdb4b63dc = 'creativeReplayComplete';
const $11e05b7353c22513$var$fireEvent = `document.dispatchEvent(new CustomEvent("${$11e05b7353c22513$export$d626e74fdb4b63dc}"));`;
const $11e05b7353c22513$export$a99ac805ed2a6f0a = ()=>`<script id="${$11e05b7353c22513$export$ccc0adacf1bcc957}">${$11e05b7353c22513$var$fireEvent}</script>`;
// We need to send even when the doc is finished serial processing
const $11e05b7353c22513$var$addFinishProcessingEvent = ()=>{
    document.body.innerHTML += $11e05b7353c22513$export$a99ac805ed2a6f0a();
};
const $11e05b7353c22513$export$a9e8db3ed7a4e02 = (adScript)=>{
    var _adScript_parentNode, _adScript_parentNode1;
    const range = document.createRange();
    range.selectNode(adScript);
    const adScriptCopyDoc = range.createContextualFragment(adScript.outerHTML);
    const adScriptCopy = adScriptCopyDoc.firstElementChild;
    if (adScriptCopy.getAttribute('src')) // https://html.spec.whatwg.org/multipage/scripting.html#attr-script-async
    // Need to explicity force async to false to skip https://html.spec.whatwg.org/multipage/scripting.html#script-processing-model
    // https://hsivonen.fi/script-execution/
    adScriptCopy.async = false;
    else {
        const scriptText = adScript.innerHTML;
        adScriptCopy.async = false;
        adScriptCopy.setAttribute('src', `data:text/javascript;charset=UTF-8,${encodeURIComponent(scriptText)}`);
    }
    (_adScript_parentNode = adScript.parentNode) === null || _adScript_parentNode === void 0 ? void 0 : _adScript_parentNode.insertBefore(adScriptCopy, adScript.nextSibling);
    (_adScript_parentNode1 = adScript.parentNode) === null || _adScript_parentNode1 === void 0 ? void 0 : _adScript_parentNode1.removeChild(adScript);
};
const $11e05b7353c22513$export$c12706c6ea5b35db = (htmlContent)=>{
    // setting innerHtml drops the host element's attributes, ie <html lang="en">
    // setting the outerHtml solves this, but setting outerHtml on document.documentElement is forbidden by the spec
    // supporting a target of document.documentElement is a must
    // Funciton fails with strict equality
    // eslint-disable-next-line eqeqeq
    if (document.documentElement == undefined) {
        const html = document.createElement('html');
        document.appendChild(html);
    }
    document.documentElement.innerHTML = htmlContent;
// options for getting attributes from the html string include DOMParser or regex, but performance is a concern
// https://developer.mozilla.org/en-US/docs/Web/API/Element/attributes#enumerating_elements_attributes
};
const $11e05b7353c22513$export$f608cc986470dd9c = (containerElement)=>{
    // https://html.spec.whatwg.org/multipage/scripting.html#list-of-scripts-that-will-execute-in-order-as-soon-as-possible
    // We cannot use createFragment because it is required to import in the body so we lose the HEAD/BODY/etc. tags
    // So we use InnerHTML which will not execute the scripts but then dynamically recreate the script tags
    // so that they will be executed (as they are not with innerHTML imported tags)
    const adScripts = containerElement.querySelectorAll('script');
    for (const adScript of adScripts)$11e05b7353c22513$export$a9e8db3ed7a4e02(adScript);
};
//https://html.spec.whatwg.org/multipage/images.html#img-inc
const $11e05b7353c22513$var$imageIsDownloading = (img)=>img.naturalWidth > 0 || img.naturalHeight > 0;
const $11e05b7353c22513$var$imageIsTrackingPixel = (img)=>img.height === 0 || img.width === 0;
const $11e05b7353c22513$var$isNotCompleteOrPartiallyLoadedOrTrackingPixel = (img)=>{
    !img.complete || $11e05b7353c22513$var$imageIsDownloading(img) || $11e05b7353c22513$var$imageIsTrackingPixel(img);
};
async function $11e05b7353c22513$export$3756c87fad410ed6() {
    const images = document.querySelectorAll('img');
    const imagePromises = Array.from(images).filter($11e05b7353c22513$var$isNotCompleteOrPartiallyLoadedOrTrackingPixel).map((img)=>new Promise((resolve)=>{
            img.addEventListener('load', ()=>{
                resolve();
            }, {
                once: true
            });
        }));
    await Promise.all(imagePromises);
}
const $11e05b7353c22513$export$a90f79d9f8011559 = (cms, cr, o, eventsChannel, state)=>{
    eventsChannel.onPreCreativeWrite(o);
    // TODO Find a way to model maximizing viewability instead of firePixelsAfter
    if ((0, $f5371cfcc04ab4e3$export$a87e2bc2a6a86c83)().isT1()) cms.sendMessage('sendEventAddedCreative');
    else if (!state.hasFiredCODPixel) {
        if (o.firePixelsAfter) cms.sendMessage('fireImpressionWithDelay');
        else cr.fireCodImpressionPixel();
        state.hasFiredCODPixel = true;
    }
};
const $11e05b7353c22513$export$57ef8964d5f436ea = async (o, cms, cr, c, eventsChannel)=>{
    // Since the initial loading event was fired when loading the messageport we need to simulate them
    // for the creative
    // TODO(https://sim.amazon.com/issues/CPP-38246) Wait for creative image resource loads in corner case
    $11e05b7353c22513$var$fireDOMContentLoadedEventForCreative();
    // TODO(https://sim.amazon.com/issues/CPP-38245) Check if this can be moved earlier
    $11e05b7353c22513$var$fireLoadEventForCreativeSinceItWasAlreadyFiredUpon();
    // TODO(https://issues.amazon.com/issues/CPP-41529) Clean up after gathering data for nested iframes.
    const nestedIframes = document.getElementsByTagName('iframe');
    if (nestedIframes.length > 0) c.countMetric('nestedIframes', 1);
    // isNoInventory is always false at this point
    const measurementMethod = o.btrPixelUrl ? await (0, $35ecde54ed03004d$export$af480fc3cfed262b)() : (0, $0aca3b7155cd1ec6$export$8cd9fc9636beb7a1);
    eventsChannel.onCreativeBeginToRender(o);
    const isBtr = measurementMethod === (0, $0aca3b7155cd1ec6$export$d8b8f22c20d3745b);
    if (isBtr) cms.sendMessage('sendEventCreativeBeginToRender');
    cms.sendMessage('sendEventCreativeLoaded', {
        isBtr: isBtr
    });
    $11e05b7353c22513$var$workAroundIOBugtt0156195085();
    (0, $912a5c234be6a76d$export$c9bec999c692425a)(o, c);
    if ($11e05b7353c22513$var$isMobile(o)) (0, $0712d692a57fc699$export$75b587028fcddc2b)(cms);
};
const $11e05b7353c22513$var$fireLoadEventForCreativeSinceItWasAlreadyFiredUpon = ()=>{
    (0, $512bd69d0cfb283b$export$8b7eff687c7ac140)('creativeLoad');
    (0, $4a3b13a78cd2b2bf$export$878eb973eaa7fb54)();
};
const $11e05b7353c22513$var$fireDOMContentLoadedEventForCreative = ()=>{
    (0, $512bd69d0cfb283b$export$8b7eff687c7ac140)('creativedomcontentloaded');
    document.dispatchEvent(new Event('DOMContentLoaded'));
};
const $11e05b7353c22513$var$isMobile = (adDetails)=>{
    var _adDetails_deviceType;
    return [
        'mweb',
        'mshop'
    ].includes((_adDetails_deviceType = adDetails.deviceType) === null || _adDetails_deviceType === void 0 ? void 0 : _adDetails_deviceType.toLowerCase());
};
const $11e05b7353c22513$var$workAroundIOBugtt0156195085 = ()=>{
    // allows clicks to propagate iframe in iOS
    // https://tt.amazon.com/0156195085
    // TODO Verify this is still needed.
    document.addEventListener('touchstart', {
        handleEvent: ()=>{
        //do nothing
        }
    }, false);
};


const $9e6bd76b3925e390$var$PLACEHOLDER_DEFAULT = '&pd_rd_plhdr=t';
/**
 *  HTML entity examples:
 *      Symbols
 *          shortest: &lt;
 *          longest: &Omicron;
 *
 *      Numbers
 *          (0-31 are control characters)
 *          shortest: &#32;
 *          longest: &#8721;
 *
 *  Regular Expressions
 *      Entity Numbers: (&#(0-){2};)|(&#(a-z){3};)|(&#(a-z){4};)
 *      Entity Symbols: (&(a-z){2};)|(&(a-z){3};)|(&(a-z){4};)|(&(a-z){5};)|(&(a-z){6};)|(&(a-z){7};)
 */ const $9e6bd76b3925e390$var$REGEX_MATCH = new RegExp(/((&#\d{2,4};)|(&[a-z]{2};)|(&[a-z]{3,7};)|(%[a-fA-F0-9]{2})|(\W))pd_rd_plhdr(=|%3D)t((&#\d{2,4};)|(&[a-z]{2,7};)|(%[a-fA-F0-9]{2})|(\W))/);
/**
 * Indices must be updated if RegEx groups are modified.
 * Each left and right group has 10 subgroups.
 * String.prototype.match() call will return the results of 22 groups.
 * Main result of the left matching group will be at index 1, while
 * the primary result of the right group is stored at index 12.
 */ const $9e6bd76b3925e390$var$LEFT_GROUP_INDEX = 1;
const $9e6bd76b3925e390$var$MIDDLE_GROUP_INDEX = 7;
const $9e6bd76b3925e390$var$RIGHT_GROUP_INDEX = 8;
const $9e6bd76b3925e390$var$LEFT_GROUP_VALUE = '$' + $9e6bd76b3925e390$var$LEFT_GROUP_INDEX;
const $9e6bd76b3925e390$var$RIGHT_GROUP_VALUE = '$' + $9e6bd76b3925e390$var$RIGHT_GROUP_INDEX;
const $9e6bd76b3925e390$export$ca536300dbd6350 = (clickTracker, htmlContent)=>{
    let content = htmlContent, replacement = clickTracker;
    if (clickTracker === $9e6bd76b3925e390$var$PLACEHOLDER_DEFAULT || clickTracker.trim() === '') return content;
    replacement = replacement.replace(/&amp;/g, '&');
    if (replacement.startsWith('&')) replacement = replacement.replace(/^&+/, '');
    if (replacement.endsWith('&')) replacement = replacement.replace(/&+$/, '');
    try {
        let match;
        let executions = 0;
        do {
            executions++;
            match = content.match($9e6bd76b3925e390$var$REGEX_MATCH);
            if (!match) break;
            const left = match[$9e6bd76b3925e390$var$LEFT_GROUP_INDEX]; // Match of main left group - not subgroups
            const right = match[$9e6bd76b3925e390$var$RIGHT_GROUP_INDEX]; // Match of main right group - not subgroups
            const middle = match[$9e6bd76b3925e390$var$MIDDLE_GROUP_INDEX]; // Match middle group (equals sign)
            const hasHtmlEntity = left.startsWith('&') && left.endsWith(';') || right.startsWith('&') && right.endsWith(';');
            const hasUrlEncoding = left.startsWith('%') && right.startsWith('%') && middle === '%3D';
            if (hasHtmlEntity) content = content.replace($9e6bd76b3925e390$var$REGEX_MATCH, $9e6bd76b3925e390$var$LEFT_GROUP_VALUE + replacement.replace(/&/g, '&amp;') + $9e6bd76b3925e390$var$RIGHT_GROUP_VALUE);
            else if (hasUrlEncoding) content = content.replace($9e6bd76b3925e390$var$REGEX_MATCH, $9e6bd76b3925e390$var$LEFT_GROUP_VALUE + encodeURIComponent(replacement) + $9e6bd76b3925e390$var$RIGHT_GROUP_VALUE);
            else content = content.replace($9e6bd76b3925e390$var$REGEX_MATCH, $9e6bd76b3925e390$var$LEFT_GROUP_VALUE + replacement + $9e6bd76b3925e390$var$RIGHT_GROUP_VALUE);
        }while (match && executions < 10);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (ex) {
        return htmlContent;
    }
    return content;
};
const $9e6bd76b3925e390$export$d10ae881b12b8ef2 = (clickTracker, url)=>{
    if (clickTracker === $9e6bd76b3925e390$var$PLACEHOLDER_DEFAULT || clickTracker.trim() === '') return url;
    const URL_PLACEHOLDER_REGEX = /pd_rd_plhdr=t/g;
    const trimAmpersands = (clickTracker)=>{
        return clickTracker.trim().replace(/^(&amp;|&)+|(&amp;|&)+$/g, '');
    };
    return url.replace(URL_PLACEHOLDER_REGEX, trimAmpersands(clickTracker));
};



const $92f44ffb972caf4b$export$1dccb9d00bd3e5be = 500;
const $92f44ffb972caf4b$export$70b034663eb8339e = async (mp, timeout = $92f44ffb972caf4b$export$1dccb9d00bd3e5be)=>{
    // Can't use race here because we need to remove the event listener
    return new Promise((resolve)=>{
        let timeoutId = -1;
        const listener = (e)=>{
            const command = e.data;
            const expectedCommand = 'percolateClickTracking';
            if (command.command !== expectedCommand) throw new Error(`Unexpected command ${command}, Expected ${expectedCommand}`);
            window.clearTimeout(timeoutId); // We don't want to fire the trigger now
            resolve(command.data);
        };
        // TODO Remove this after we have made sure it works
        timeoutId = window.setTimeout(()=>{
            mp.removeEventListener('message', listener); // Don't want to process the next message as it won't be what we expect!
            resolve('');
            (0, $b57dd1b6deb577cc$export$4cdc8edb1e3c510c)(`Did not receive percolateClickTracking within ${timeout}ms`);
        }, timeout);
        mp.addEventListener('message', listener, {
            once: true
        });
        mp.start();
    });
};


class $870aa310c12e2482$export$35071041c52d2f9b extends Error {
}
const $870aa310c12e2482$export$b8a647cfefa83e04 = (adDetails, options)=>{
    const { onReport: onReport = ()=>{} } = options;
    // @NOTE(calwlai): Clean this up when API is widely available:
    // TT: https://sim.amazon.com/issues/CPP-40204
    if (typeof window.ReportingObserver !== 'undefined') {
        const checkReports = (reports = [])=>{
            const interventionReportAdDetails = $870aa310c12e2482$export$acde138454a2189d(adDetails);
            reports.forEach((report)=>{
                if (report.type === 'intervention') {
                    const error = new $870aa310c12e2482$export$35071041c52d2f9b(JSON.stringify({
                        adDetails: interventionReportAdDetails,
                        report: report.toJSON()
                    }));
                    onReport(error);
                }
            });
        };
        const reportingObserver = new ReportingObserver(checkReports, {
            buffered: true
        });
        // start observer
        reportingObserver.observe();
        // setup a visibility listener, as an intervention will begin to unload the iframe and reports may otherwise be
        // missed
        document.addEventListener('pagehide', ()=>{
            // pull all pending reports from the queue
            checkReports(reportingObserver.takeRecords());
        });
    }
};
const $870aa310c12e2482$export$acde138454a2189d = (adDetails)=>{
    const { adCreativeMetaData: adCreativeMetaData, creative: creative, slotName: slotName, placementId: placementId, placementName: placementName, pageType: pageType } = adDetails;
    return {
        adCreativeMetaData: adCreativeMetaData,
        creative: creative,
        slotName: slotName,
        placementId: placementId,
        placementName: placementName,
        pageType: pageType
    };
};



const $16313421ce85b25e$export$a9861bd62f48e142 = 'aUAZqFtiIp6VxqpW3coqZ2JdZnV3RN9S8yKMRIdJ';


const $0e984bcea2c62ab8$export$55241f5055ecb721 = 'https://qdbx3pbnx6veby23pzgaowu3q40tmmrr.lambda-url.us-east-1.on.aws';
const $0e984bcea2c62ab8$export$86880b4b2e1a2384 = 'APE_CW_METRICS';
const $0e984bcea2c62ab8$export$3577ba943a5537ec = 10;
let $0e984bcea2c62ab8$var$unloadHookRegistered = false;
const $0e984bcea2c62ab8$export$8167e1d5cd762635 = ()=>{
    $0e984bcea2c62ab8$var$unloadHookRegistered = false;
};
const $0e984bcea2c62ab8$export$4d95c473c15d37bb = (event)=>{
    if (!$0e984bcea2c62ab8$var$unloadHookRegistered) {
        window.addEventListener('beforeunload', ()=>$0e984bcea2c62ab8$var$flushAndClear());
        $0e984bcea2c62ab8$var$unloadHookRegistered = true;
    }
    const cache = $0e984bcea2c62ab8$var$getCache();
    cache.push(event);
    if (cache.length >= $0e984bcea2c62ab8$export$3577ba943a5537ec) $0e984bcea2c62ab8$var$flushCache(cache);
    else $0e984bcea2c62ab8$var$updateCache(cache);
};
const $0e984bcea2c62ab8$var$getCache = ()=>{
    const data = localStorage.getItem($0e984bcea2c62ab8$export$86880b4b2e1a2384);
    if (!data) return [];
    try {
        return JSON.parse(data);
    } catch (e) {
        return [];
    }
};
const $0e984bcea2c62ab8$var$flushCache = (metrics)=>{
    navigator.sendBeacon($0e984bcea2c62ab8$export$55241f5055ecb721, JSON.stringify(metrics));
    localStorage.removeItem($0e984bcea2c62ab8$export$86880b4b2e1a2384);
};
const $0e984bcea2c62ab8$var$updateCache = (metrics)=>{
    localStorage.setItem($0e984bcea2c62ab8$export$86880b4b2e1a2384, JSON.stringify(metrics));
};
const $0e984bcea2c62ab8$var$flushAndClear = ()=>{
    const cache = $0e984bcea2c62ab8$var$getCache();
    if (cache.length > 0) $0e984bcea2c62ab8$var$flushCache(cache);
};


const $816aae5f5b214b4c$export$9ea8a38bad9aea1 = ({ metricName: metricName, adDetails: adDetails, count: count = 1, additionalDimensions: additionalDimensions = {} })=>{
    if ((0, $f5371cfcc04ab4e3$export$eb0afc859cf95bf8)().isT1()) (0, $0e984bcea2c62ab8$export$4d95c473c15d37bb)($816aae5f5b214b4c$var$toPostMetricDTO(metricName, count, $816aae5f5b214b4c$var$toSFDimensions(adDetails, additionalDimensions)));
};
const $816aae5f5b214b4c$export$c35f03b0a112edb6 = ({ metricName: metricName, adDetails: adDetails, count: count = 1, additionalDimensions: additionalDimensions = {} })=>{
    if ((0, $f5371cfcc04ab4e3$export$b0ca8c371c8fd3bd)().isT1()) (0, $0e984bcea2c62ab8$export$4d95c473c15d37bb)($816aae5f5b214b4c$var$toPostMetricDTO(metricName, count, $816aae5f5b214b4c$var$toSFDimensions(adDetails, additionalDimensions)));
};
const $816aae5f5b214b4c$export$f816489358063a5f = ({ metricName: metricName, lightAdDetails: lightAdDetails, count: count = 1, additionalDimensions: additionalDimensions = {} })=>{
    if ((0, $f5371cfcc04ab4e3$export$eb0afc859cf95bf8)().isT1()) (0, $0e984bcea2c62ab8$export$4d95c473c15d37bb)($816aae5f5b214b4c$var$toPostMetricDTO(metricName, count, $816aae5f5b214b4c$var$toLADimensions(lightAdDetails, additionalDimensions)));
};
const $816aae5f5b214b4c$export$777f19a9c0612ad2 = ({ metricName: metricName, lightAdDetails: lightAdDetails, count: count = 1, additionalDimensions: additionalDimensions = {} })=>{
    if ((0, $f5371cfcc04ab4e3$export$b0ca8c371c8fd3bd)().isT1()) (0, $0e984bcea2c62ab8$export$4d95c473c15d37bb)($816aae5f5b214b4c$var$toPostMetricDTO(metricName, count, $816aae5f5b214b4c$var$toLADimensions(lightAdDetails, additionalDimensions)));
};
const $816aae5f5b214b4c$var$toPostMetricDTO = (metricName, count, dimensions)=>({
        metricName: metricName,
        timestamp: new Date().getTime(),
        count: count,
        dimensions: dimensions,
        xApiKey: (0, $16313421ce85b25e$export$a9861bd62f48e142)
    });
const $816aae5f5b214b4c$var$toSFDimensions = (adDetails, additionalDimensions)=>{
    var _adDetails_adCreativeMetaData, _adDetails_adCreativeMetaData1;
    return {
        app: 'SF',
        siteName: adDetails.siteName,
        slotName: adDetails.slotName,
        pageType: adDetails.pageType,
        placementId: adDetails.placementId,
        mediaType: adDetails.mediaType,
        programId: (_adDetails_adCreativeMetaData = adDetails.adCreativeMetaData) === null || _adDetails_adCreativeMetaData === void 0 ? void 0 : _adDetails_adCreativeMetaData.adProgramId,
        creativeTemplateName: (_adDetails_adCreativeMetaData1 = adDetails.adCreativeMetaData) === null || _adDetails_adCreativeMetaData1 === void 0 ? void 0 : _adDetails_adCreativeMetaData1.adCreativeTemplateName,
        deviceType: adDetails.deviceType,
        creativeId: adDetails.adCreativeMetaData.adCreativeId,
        ...additionalDimensions
    };
};
const $816aae5f5b214b4c$var$toLADimensions = (adDetails, additionalDimensions)=>{
    var _adDetails_adCreativeMetaData, _adDetails_adCreativeMetaData1;
    return {
        app: 'LA',
        siteName: adDetails.siteName,
        slotName: adDetails.slotName,
        pageType: adDetails.pageType,
        placementId: adDetails.placementId,
        mediaType: adDetails.videoCreative ? 'V' : 'D',
        programId: (_adDetails_adCreativeMetaData = adDetails.adCreativeMetaData) === null || _adDetails_adCreativeMetaData === void 0 ? void 0 : _adDetails_adCreativeMetaData.adProgramId,
        creativeTemplateName: (_adDetails_adCreativeMetaData1 = adDetails.adCreativeMetaData) === null || _adDetails_adCreativeMetaData1 === void 0 ? void 0 : _adDetails_adCreativeMetaData1.adCreativeTemplateName,
        deviceType: adDetails.deviceType,
        creativeId: adDetails.adCreativeMetaData.adCreativeId,
        ...additionalDimensions
    };
};



const $3340aab1905848ed$export$a795902369465202 = (adDetails)=>{
    if (!adDetails.htmlContentEncoded || adDetails.htmlContentEncoded.trim().length === 0) throw new Error('No html content found on a server side fetch');
    const htmlContent = adDetails.htmlContentEncodedLength ? adDetails.htmlContentEncoded : (0, $149045d10d157dc3$export$867e660d90f641b0)(adDetails.htmlContentEncoded);
    $3340aab1905848ed$var$logIfError(htmlContent, adDetails.htmlContentEncodedLength);
    return htmlContent;
};
const $3340aab1905848ed$var$logIfError = (htmlContent, htmlContentEncodedLength)=>{
    if (htmlContentEncodedLength && htmlContent.length !== htmlContentEncodedLength) console.debug(`Mismatched expected htmlContentEncoded size. Expected ${htmlContentEncodedLength} but got ${htmlContent.length}`);
};



const $f39c20b54fb4f86c$export$672f2f7ee343e120 = (defaultNumber = -1)=>{
    let cachedNumber = defaultNumber;
    return {
        set (value) {
            cachedNumber = value;
        },
        get () {
            return cachedNumber;
        }
    };
};


const $c3877819f4bab61d$export$e6cb536eff0f481b = {
    win: {
        t: 0,
        b: 0,
        l: 0,
        r: 0,
        w: 0,
        h: 0
    },
    self: {
        t: 0,
        l: 0,
        r: 0,
        b: 0,
        xiv: 0,
        yiv: 0,
        iv: 0,
        z: 0,
        w: 0,
        h: 0
    },
    exp: {
        t: 0,
        l: 0,
        r: 0,
        b: 0,
        xs: 0,
        yx: 0
    }
};
const $c3877819f4bab61d$export$5c0d0f11d7078a3 = (initial = $c3877819f4bab61d$export$e6cb536eff0f481b)=>{
    const cachedGeom = initial;
    return {
        set (newGeom) {
            cachedGeom.self = {
                ...cachedGeom.self,
                ...newGeom.self
            };
        },
        get () {
            return cachedGeom;
        }
    };
};


const $b7d5d180fb24513c$export$55a5663e31ce86e8 = (0, $f39c20b54fb4f86c$export$672f2f7ee343e120)();
const $b7d5d180fb24513c$export$1148ab142676aac0 = (0, $c3877819f4bab61d$export$5c0d0f11d7078a3)();
const $b7d5d180fb24513c$export$1b4d14d669307982 = ()=>{
    return {
        ext: {
            /**
             * @desc Gives the inViewPercentage of the SafeFrame container as a whole number in [0, 100]
             * @returns {Number} returns the inView percentage of the SafeFrame container
             */ inViewPercentage: ()=>$b7d5d180fb24513c$export$55a5663e31ce86e8.get(),
            /**
             * @desc Gives the geometric dimension and location of SafeFrame container
             */ geom: ()=>$b7d5d180fb24513c$export$1148ab142676aac0.get()
        }
    };
};





const $f4e78b1c8322b4c1$export$af16e2ceadddb8a1 = async (htmlContent)=>{
    const eventFired = $f4e78b1c8322b4c1$var$waitForCreativeReplayComplete();
    $f4e78b1c8322b4c1$export$6967e99e3ee2b5f9(htmlContent, (0, $11e05b7353c22513$export$a99ac805ed2a6f0a)());
    await eventFired;
};
const $f4e78b1c8322b4c1$var$waitForCreativeReplayComplete = ()=>new Promise((resolve, reject)=>{
        document.addEventListener((0, $11e05b7353c22513$export$d626e74fdb4b63dc), ()=>resolve(), {
            once: true
        });
        setTimeout(()=>reject(new Error(`${(0, $11e05b7353c22513$export$d626e74fdb4b63dc)} timeout after 5 seconds`)), 5000);
    });
const $f4e78b1c8322b4c1$export$6967e99e3ee2b5f9 = (...text)=>{
    const htmlContent = text.filter((x)=>!!x).map(String).join('');
    // The below conditional checks if an inline script is running AND that document has not
    // finished painting. In this case, document.write should append to the document immediately
    // below that script, as described here: https://www.oreilly.com/library/view/javascript-the-definitive/0596000480/re204.html
    // In all other cases we will replace the contents of the document with the string passed to document.write.
    if (document.currentScript !== null) {
        let currentElement = document.currentScript;
        currentElement.insertAdjacentHTML('afterend', htmlContent);
        // Scripts do not execute when added via html string. Need to replay each script after the
        // insertion point (via next sibling). If we used replayAll on the body, it would infinitely
        // loop by replaying the script which called renderHTML in the first place.
        currentElement = currentElement.nextElementSibling;
        while(currentElement !== null){
            if (currentElement.tagName === 'SCRIPT') (0, $11e05b7353c22513$export$a9e8db3ed7a4e02)(currentElement);
            else (0, $11e05b7353c22513$export$f608cc986470dd9c)(currentElement);
            currentElement = currentElement.nextElementSibling;
        }
    } else {
        (0, $11e05b7353c22513$export$c12706c6ea5b35db)(htmlContent);
        (0, $11e05b7353c22513$export$f608cc986470dd9c)(document.documentElement);
    }
};


class $4a3b13a78cd2b2bf$export$3506e262fca74394 {
    tryEncapsulateInWrapper(htmlContent) {
        if (this.o.creativeWrapperDivEncoded) {
            this.c.countMetric('creativeWrapperDivEncoded', 1, true);
            const creativeWrapperDiv = (0, $149045d10d157dc3$export$f65d427d70ef5760)(this.o.creativeWrapperDivEncoded);
            const creativeInsertPosition = creativeWrapperDiv.lastIndexOf('</div>');
            return [
                creativeWrapperDiv.slice(0, creativeInsertPosition),
                htmlContent,
                creativeWrapperDiv.slice(creativeInsertPosition)
            ].join('');
        }
        return htmlContent;
    }
    constructor(o, mp, cms, cmr, c, eventsChannel){
        this.o = o;
        this.mp = mp;
        this.cms = cms;
        this.cmr = cmr;
        this.c = c;
        this.eventsChannel = eventsChannel;
        this.renderCompleteTime = null;
        this.state = {
            hasFiredCODPixel: false
        };
        this.clickTrackingParam = ''; // Containers the clickTrackingParam passed from the host
        this.logInterventionReport = (error)=>{
            // log to cloudwatch
            (0, $816aae5f5b214b4c$export$9ea8a38bad9aea1)({
                metricName: 'reporting-observer:heavy-ad-intervention',
                adDetails: this.o
            });
            // log to RTLA
            this.c.logFatal('heavy-ad-intervention', error);
        };
        this.initSFClient = async ({ timeout: timeout = (0, $92f44ffb972caf4b$export$1dccb9d00bd3e5be) } = {})=>{
            this.ensureGlobals();
            /* Disable creative access to set and get cookies: https://issues.amazon.com/issues/APEX-4377 */ (0, $b3a71d4461d0cfe8$export$7b0ce1a6e0e55f7a)();
            /* Disable geolocation API: https://issues.amazon.com/issues/CPP-24902 */ (0, $b3a71d4461d0cfe8$export$a61d9e10c3bd524f)();
            /*
             * Called by the creative for further mutations to the DOM
             */ if ((0, $f5371cfcc04ab4e3$export$d3cb3e0b348d5258)().isT1()) document.write = (0, $f4e78b1c8322b4c1$export$6967e99e3ee2b5f9);
            else document.write = this.documentWriteDelegate;
            // Send clientBodyEnd after setting up the safeframe APIs
            this.c.sendLatencyMetric((0, $868ff823e8351ef6$export$ddd0fb968b6370bc));
            this.eventsChannel.onSafeFrameReady(this.o);
            // Wait for the Percolate Click Tracking To Come Back
            if (!(0, $f5371cfcc04ab4e3$export$88fbf8076ec05b)().isT1()) this.clickTrackingParam = await (0, $92f44ffb972caf4b$export$70b034663eb8339e)(this.mp, timeout);
            // We don't want to start processing messages in the host message receiver until we have gotten the
            // percolate click tracking param
            this.mp.onmessage = this.cmr.receiveMessage;
            this.c.countMetric((0, $1ed025fb74d72694$export$e82123d0c5506f35), 1);
            this.c.logCsaEvent($7b4b43381f421ea5$export$e82123d0c5506f35);
            await this.writeCreativeToDocument();
        };
        /**
         * This should only be called once per iframe. Inserts the creative html into the iframe document's DOM.
         * Currently, we assume all video ad creatives which use the safeframe have a built-in video player.
         * VAST ads should be rendered through LightAds.
         * We expect the synthetic load event to be fired during this code path
         */ this.writeCreativeToDocument = async ()=>{
            $4a3b13a78cd2b2bf$var$addSyntheticOnLoadListeners(this, this.o);
            try {
                this.o.isNoInventory = false;
                let htmlContent = (0, $9e6bd76b3925e390$export$ca536300dbd6350)(this.clickTrackingParam, (0, $3340aab1905848ed$export$a795902369465202)(this.o));
                htmlContent = this.tryEncapsulateInWrapper(htmlContent);
                (0, $11e05b7353c22513$export$a90f79d9f8011559)(this.cms, this.c.cr, this.o, this.eventsChannel, this.state);
                if ((0, $f5371cfcc04ab4e3$export$d3cb3e0b348d5258)().isT1()) {
                    await (0, $f4e78b1c8322b4c1$export$af16e2ceadddb8a1)(htmlContent);
                    this.renderCompleteTime = new Date();
                } else await this.documentWriteDelegate(htmlContent);
                this.eventsChannel.onPostCreativeWrite(this.o);
                await (0, $11e05b7353c22513$export$57ef8964d5f436ea)(this.o, this.cms, this.c.cr, this.c, this.eventsChannel);
                this.eventsChannel.onCreativeLoad(this.o);
                if ((0, $f5371cfcc04ab4e3$export$88fbf8076ec05b)().isT1()) document.body.addEventListener('click', ()=>{
                    this.eventsChannel.onClick(this.o);
                }, {
                    once: true
                });
            } catch (err) {
                this.c.logError('Failed to get creative content', err);
                this.c.collapseSlotInternal('CLIENTSETUP');
                this.eventsChannel.onError(this.o);
            }
        };
        this.ensureGlobals = ()=>{
            window.onerror = this.handleErrors;
            var _window_$sf;
            window.$sf = (_window_$sf = window.$sf) !== null && _window_$sf !== void 0 ? _window_$sf : (0, $b7d5d180fb24513c$export$1b4d14d669307982)();
            window.$sfViewableInfo = (0, $c2b6fbe269a16f75$export$e4936ec1fd020a06)();
            window.aaxInstrPixelUrl = this.o.aaxInstrPixelUrl;
        };
        /**
         * This method can be called multiple times during the lifecycle
         */ this.documentWriteDelegate = async (htmlContent)=>await (0, $11e05b7353c22513$export$9da576b8d2431e13)(htmlContent, this, this.c, this.o);
        /* Overwrite the window's onerror method to catch any unexpected errors
         * coming from the creative code. We will log the error and attempt to
         * show a different ad or collapse the slot.
         */ this.handleErrors = (message, source, lineno, colno, errorObject)=>{
            const err = errorObject || new Error(message.toString());
            this.c.logError(`Window.onerror triggered inside of the iframe. Src: ${source}:${lineno}:${colno}`, err);
            if ((0, $f5371cfcc04ab4e3$export$f201cea58945cab5)().isT1()) // Check if the creative has begun to render properly, if not collapse the ad slot
            {
                if (!(0, $c9ce6323b43f3e14$export$6d47de433179ae29)(document.body).success) this.c.collapseSlotInternal('CLIENTERROR');
            } else if (!this.renderCompleteTime) this.c.collapseSlotInternal('CLIENTERROR');
            this.eventsChannel.onError(this.o);
            // Returning true suppresses the default browser behavior
            return true;
        };
        /*
         * Override document.open so we can detect future writes and ensure globals are set
         */ const originalDocumentOpen = document.open.bind(document);
        document.open = (...args)=>{
            const result = originalDocumentOpen(...args);
            this.ensureGlobals();
            return result;
        };
        this.nativeWrite = document.write.bind(document);
        window.onerror = this.handleErrors;
        // log heavy ad interventions. See https://developer.chrome.com/blog/heavy-ad-interventions
        (0, $870aa310c12e2482$export$b8a647cfefa83e04)(this.o, {
            onReport: this.logInterventionReport
        });
    }
}
// We generate our own synthetic load event for the creative to hook (since the initial sf script and html already fired it)
// we expect a matching call to generateSyntheticLoadEvent to be generated
const $4a3b13a78cd2b2bf$var$addSyntheticOnLoadListeners = (client, adDetails)=>{
    if (!adDetails.creativeSupportsTTIMeasurement) window.addEventListener('load', ()=>(0, $b3a71d4461d0cfe8$export$1dbacc10782d79ff)(client.c), {
        once: true
    });
    window.addEventListener('load', ()=>client.c.fireViewableLatencyMetrics(), {
        once: true
    });
};
const $4a3b13a78cd2b2bf$export$878eb973eaa7fb54 = ()=>{
    window.dispatchEvent(new Event('load'));
};


class $b992f02665ee6647$var$MessageCallbackImpl {
    constructor(messageName, c, cms){
        this.messageName = messageName;
        this.c = c;
        this.cms = cms;
        this.execute = (data)=>{
            this.c.logAPIInvocation(this.messageName);
            this._successCallback = data.successCallback;
            this._failCallback = data.failCallback;
            this.cms.sendMessage(this.messageName, data);
        };
        this.update = (data)=>{
            if (typeof data.value === 'undefined') {
                if (this._successCallback) this._successCallback();
            } else if (this._failCallback) // TODO Fix this type override
            this._failCallback(data.value || data.errorMsg);
        };
    }
}
class $b992f02665ee6647$export$22e96a5976ace877 extends $b992f02665ee6647$var$MessageCallbackImpl {
    constructor(c, cms){
        super('openInExternalBrowser', c, cms);
    }
}
class $b992f02665ee6647$export$aed8a26fe1d9f0da extends $b992f02665ee6647$var$MessageCallbackImpl {
    constructor(c, cms){
        super('showEmbeddedBrowser', c, cms);
    }
}
class $b992f02665ee6647$export$43e72c01d1e9760 extends $b992f02665ee6647$var$MessageCallbackImpl {
    constructor(c, cms){
        super('launchIntentURL', c, cms);
    }
}
class $b992f02665ee6647$export$5d17ef21cb33f789 extends $b992f02665ee6647$var$MessageCallbackImpl {
    constructor(c, cms){
        super('openInApp3pBrowser', c, cms);
    }
}
class $b992f02665ee6647$export$ae62af5864067f17 {
    constructor(c, cms, o){
        this.o = o;
        /**
         * TODO Remove this
         * @deprecated This is always true and also irrelevant since the client has no direct access to the AUI anyways
         */ this.isAUIAvailable = ()=>{
            return true;
        };
        this.openInExternalBrowser = new $b992f02665ee6647$export$22e96a5976ace877(c, cms);
        this.showEmbeddedBrowser = new $b992f02665ee6647$export$aed8a26fe1d9f0da(c, cms);
        this.launchIntentURL = new $b992f02665ee6647$export$43e72c01d1e9760(c, cms);
        this.openInApp3pBrowser = new $b992f02665ee6647$export$5d17ef21cb33f789(c, cms);
    }
}


/**
 * @desc Contains safeframe client APIs that are common to desktop and mobile safeframe.
 */ 






class $28e094dd001dcab4$export$26e23c7200e8a435 {
    constructor(cms, o, mL){
        this.cms = cms;
        this.o = o;
        this.mL = mL;
        this.fireImpression = async (_data)=>{
            this.sendLatencyMetric((0, $868ff823e8351ef6$export$abd3b2c5ae6ac709));
            await this.cr.fireCodImpressionPixel();
        };
        this.changeSize = (width, height)=>{
            this.cms.sendMessage('changeSize', {
                width: width,
                height: height
            });
        };
        this.logCsaEvent = (metricName)=>{
            this.cms.sendMessage('logCsaEvent', {
                metricName: metricName
            });
        };
        this.registerCustomMessageListener = (msgKey, callback)=>{
            this.mL[msgKey] = callback;
            this.countMetric('sf:commonmain:registerCustomMessageListener', 1, true);
        };
        this.sendLatencyMetric = (latencyMetricType)=>{
            this.cms.sendMessage('sendLatencyMetric', {
                latencyMetricType: latencyMetricType,
                timestamp: new Date()
            });
        };
        this.countMetric = (msg, num = 1, isGlobal = false)=>{
            this.cms.sendMessage('countMetric', {
                metricMsg: msg,
                value: num,
                isGlobal: isGlobal
            });
        };
        this.fireViewableLatencyMetrics = ()=>{
            this.cms.sendMessage('fireViewableLatencyMetrics', {
                adLoadedTimestamp: Date.now()
            });
        };
        /**
         * @desc Used by Creative template owners to trigger metric for 'Sponsored Label' rendered.
         */ this.feedbackLabelRendered = ()=>{
            this.cms.sendMessage('feedbackLabelRendered');
        };
        /**
         * @desc Used by Creative template owners to open feedback Modal.
         */ this.feedbackOpenModal = ()=>{
            this.cms.sendMessage('feedbackOpenModal');
        };
        this.updateViewability = (data)=>{
            var _window_$sf_ext, _window_$sf, _window, _window_$sf1, _window1, _geom_self, _geom_self1;
            const clientSfViewableInfo = (0, $c2b6fbe269a16f75$export$e4936ec1fd020a06)();
            // update cached viewability for synchronous viewability access
            (0, $c2b6fbe269a16f75$export$722fbec263ad908a)(data);
            if (!this.o.aaxInstrPixelUrl || !clientSfViewableInfo.payload || !clientSfViewableInfo.viewabilityStandards) return;
            const geom = ((_window = window) === null || _window === void 0 ? void 0 : (_window_$sf = _window.$sf) === null || _window_$sf === void 0 ? void 0 : (_window_$sf_ext = _window_$sf.ext) === null || _window_$sf_ext === void 0 ? void 0 : _window_$sf_ext.geom) && ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_$sf1 = _window1.$sf) === null || _window_$sf1 === void 0 ? void 0 : _window_$sf1.ext.geom());
            const cachedViewability = (geom === null || geom === void 0 ? void 0 : (_geom_self = geom.self) === null || _geom_self === void 0 ? void 0 : _geom_self.iv) ? geom === null || geom === void 0 ? void 0 : (_geom_self1 = geom.self) === null || _geom_self1 === void 0 ? void 0 : _geom_self1.iv : null;
            if ((0, $149045d10d157dc3$export$ac5608bbe92d6fdc)(this.o.mediaType)) {
                const clientSfPlayingTimeInfo = (0, $c2b6fbe269a16f75$export$cadfdfaff71363e)();
                this.cr.fireViewablePixelsForVideo(cachedViewability, clientSfViewableInfo.payload(), clientSfViewableInfo.viewabilityStandards(), this.o.isNoInventory ? true : false, clientSfPlayingTimeInfo.playingTime ? clientSfPlayingTimeInfo.playingTime() : null);
            }
        };
        /**
         * Viewability pixels for video are fired from a combination of time spent in the view port and time spent playing.
         * For ad templates which implement their own video player (ie Sponsored Display's PERC), they need to tell SF how much
         * time has been spent playing. SF will combine this with its knowledge of in view time to determine when to fire a
         * viewability pixel.
         *
         * @param continuousPlaybackSeconds - This is the maximum amount of continuous playback time the videoplayer has observed (in seconds)
         */ this.updatePlayingTimeForVideo = (continuousPlaybackSeconds)=>{
            if ((0, $f5371cfcc04ab4e3$export$1f8bd04ee7de0dc0)().isT1()) // Send message from iframe to host on the updated continuousPlaybackSeconds
            this.cms.sendMessage('sendSfVideoContinuousPlaytimeSeconds', {
                sfVideoContinuousPlaytimeSeconds: continuousPlaybackSeconds
            });
            else {
                var _window_$sf_ext, _window_$sf, _window, _geom_self;
                const clientSfViewableInfo = (0, $c2b6fbe269a16f75$export$e4936ec1fd020a06)();
                (0, $c2b6fbe269a16f75$export$a2ff20089055e79d)(continuousPlaybackSeconds);
                const geom = ((_window = window) === null || _window === void 0 ? void 0 : (_window_$sf = _window.$sf) === null || _window_$sf === void 0 ? void 0 : (_window_$sf_ext = _window_$sf.ext) === null || _window_$sf_ext === void 0 ? void 0 : _window_$sf_ext.geom) && window.$sf.ext.geom();
                const cachedViewability = geom === null || geom === void 0 ? void 0 : (_geom_self = geom.self) === null || _geom_self === void 0 ? void 0 : _geom_self.iv;
                if (cachedViewability && clientSfViewableInfo.payload && clientSfViewableInfo.viewabilityStandards) {
                    const clientSfPlayingTimeInfo = (0, $c2b6fbe269a16f75$export$cadfdfaff71363e)();
                    this.cr.fireViewablePixelsForVideo(cachedViewability, clientSfViewableInfo.payload(), clientSfViewableInfo.viewabilityStandards(), this.o.isNoInventory ? true : false, clientSfPlayingTimeInfo.playingTime ? clientSfPlayingTimeInfo.playingTime() : null);
                }
            }
        };
        this.requestVideoAutoplay = ()=>{
            this.cms.sendMessage('requestVideoAutoplay');
        };
        this.releaseVideoAutoplay = ()=>{
            this.cms.sendMessage('releaseVideoAutoplay');
        };
        this.haveVideoAutoplayPermission = ()=>{
            this.cms.sendMessage('haveVideoAutoplayPermission');
        };
        this.isOnAmazon = ()=>{
            return true;
        };
        this.logError = (message, error, level)=>{
            this.cms.sendMessage('logError', {
                message: message,
                error: error,
                level: level
            });
        };
        this.logFatal = (message, error, level)=>{
            this.cms.sendMessage('logFatal', {
                message: message,
                error: error,
                level: level
            });
        };
        /**
         * @deprecated Use collapseSlot instead
         */ this.collapseSlotInternal = (code)=>{
            this.logAPIInvocation('collapseSlot');
            this.cms.sendMessage('collapseSlot', code);
        };
        this.collapseSlot = ()=>{
            this.collapseSlotInternal('CREATIVE');
        };
        this.resizeCreativeWrapper = (data)=>{
            const creativeWrapper = window.document.getElementById(`ape_${this.o.scope}_creativeWrapper`);
            if (creativeWrapper === null) return;
            creativeWrapper.style.height = data.height;
            creativeWrapper.style.width = data.width;
        };
        /**
         * Used to emit a custom event to the ad notifying that an event occurred outside the safeframe.
         * @param data object containing the name of the event which is being propagated to the ad
         */ this.triggerEventInIframe = (data)=>{
            window.dispatchEvent(new Event('outerpage' + data.eventType));
        };
        this.logAPIInvocation = (apiName, ...apiParams)=>{
            const API = 'messenger_';
            this.cms.sendMessage('logAPIInvocation', {
                apiName: apiName,
                apiParams: apiParams
            });
            this.cms.sendMessage('logCsaEvent', {
                metricName: API + apiName
            });
        };
        this.setupComputedAdDetails = (data)=>{
            window.aPageStart = data.aPageStart;
            window.adStartTime = data.adStartTime;
        };
        this.signalAdLoadedAndInteractive = ()=>{
            (0, $b3a71d4461d0cfe8$export$1dbacc10782d79ff)(this);
        };
        /**
         *
         * Client sends domain event to host to fire the
         * COD impression pixel using the Light Ads logic
         */ this.sendEventAddedCreative = ()=>{
            this.cms.sendMessage('sendEventAddedCreative');
        };
        this.populateGeom = (message)=>(0, $b7d5d180fb24513c$export$1148ab142676aac0).set(message.geom);
        this.populateSafeFrameExt = (message)=>{
            (0, $b7d5d180fb24513c$export$55a5663e31ce86e8).set(message.inViewPercentage);
            (0, $b7d5d180fb24513c$export$1148ab142676aac0).set(message.geom);
        };
        this.cr = new (0, $35ecde54ed03004d$export$50627d05c9061249)(this, o);
    }
}


const $53704daf19feb304$var$CONNECTION_TYPE_UNKNOWN = 'unknown';
const $53704daf19feb304$var$MOBILE_CONNECTION_TYPE_UNKNOWN = 0;
const $53704daf19feb304$var$getConnectionInfo = ()=>{
    const navigatorObject = window.navigator;
    const connection = navigatorObject === null || navigatorObject === void 0 ? void 0 : navigatorObject.connection;
    return (connection === null || connection === void 0 ? void 0 : connection.type) || (connection === null || connection === void 0 ? void 0 : connection.effectiveType) || $53704daf19feb304$var$CONNECTION_TYPE_UNKNOWN;
};
const $53704daf19feb304$export$c322d029f938aae3 = (amznAppContextCookie)=>{
    var _getAmznAppContextFromCookie_di, _getAmznAppContextFromCookie;
    const mobileConnectionType = amznAppContextCookie ? (_getAmznAppContextFromCookie = $53704daf19feb304$var$getAmznAppContextFromCookie(amznAppContextCookie)) === null || _getAmznAppContextFromCookie === void 0 ? void 0 : (_getAmznAppContextFromCookie_di = _getAmznAppContextFromCookie.di) === null || _getAmznAppContextFromCookie_di === void 0 ? void 0 : _getAmznAppContextFromCookie_di.ct : $53704daf19feb304$var$MOBILE_CONNECTION_TYPE_UNKNOWN;
    console.error(mobileConnectionType);
    // User context is the data received from MASH application context
    return {
        connectionType: $53704daf19feb304$var$getConnectionInfo(),
        mobileConnectionType: mobileConnectionType || $53704daf19feb304$var$MOBILE_CONNECTION_TYPE_UNKNOWN
    };
};
/**
 * From https://w.amazon.com/bin/view/MASH/Application_Context_Protocol
 */ const $53704daf19feb304$var$getAmznAppContextFromCookie = (mashCookieValue)=>{
    const MASH_COOKIE_REGEX = /^([.\d]*\s*)({.*})$/;
    const cookieSplitArray = MASH_COOKIE_REGEX.exec(mashCookieValue);
    return JSON.parse(cookieSplitArray[2]);
};


class $9b1bc92cd0529901$export$8b15f44b658c097f extends (0, $28e094dd001dcab4$export$26e23c7200e8a435) {
    constructor(cms, o, mL){
        super(cms, o, mL);
        this.onPageEvent = {
            callback: ()=>{
            /**/ },
            execute: (eventName, callback)=>{
                this.logAPIInvocation('onPageEvent');
                this.onPageEvent.callback = callback;
                this.cms.sendMessage('onPageEvent', {
                    eventName: eventName
                });
            },
            update: ()=>{
                if (typeof this.onPageEvent.callback === 'function') this.onPageEvent.callback();
            }
        };
        /**
         * @func renderClickThroughAppAds
         * @desc Renders click-through app ads for SKAdNetwork attribution on iOS.
         *  * This handles the SKAN click-through attribution when a user clicks on an app ad.
         *  * It uses the MASH API to communicate with the native iOS layer for proper SKAdNetwork attribution.
         *
         * @see https://developer.apple.com/documentation/storekit/skadnetwork
         * @param url {URL} The fallback url used to pass to MASH API
         *
         * @example
         *  const url = new URL("https://apps.apple.com/us/app/tapier/id6476941533?aref=0LAPHaEBAS");
         *  renderClickThroughAppAds(url);
         *
         * Note, adDetails object is passed by default in sendMessage which includes SKAdNetwork object to call SKAN API.
         */ this.renderClickThroughAppAds = (url)=>{
            this.logAPIInvocation('renderClickThroughAppAds');
            this.cms.sendMessage('renderClickThroughAppAds', url.href);
        };
        /**
         * @func sendAdInfo
         * @desc [Internal & External] Sends information about creative ID / program ID to page, to send to AdFeedback team
         * @param {*} mobileAdsInfo - Information passed in by the creatives
         */ this.sendAdInfo = (mobileAdsInfo)=>{
            if (mobileAdsInfo) this.cms.sendMessage('getAdInfo', {
                mobileAdsInfo: mobileAdsInfo
            });
        };
        this.getPlacementInfo = ()=>{
            this.logAPIInvocation('getPlacementInfo');
            const placementInfo = {
                pageType: this.o.pageType,
                slotName: this.o.slotName,
                subPageType: this.o.subPageType
            };
            return placementInfo;
        };
        // TODO Move this to public API
        this.getUserAgentInfo = ()=>{
            // TODO Eliminate the override here
            return window.navigator.userAgent;
        };
        /**
         * @deprecated Do not use this anymore.  Use direct APIs
    
         * @desc Returns the amzn-app-ctxt cookie if it exists
         * @returns {String} cookie - amzn-app-ctxt
         */ this.getDocumentCookie = ()=>{
            this.logAPIInvocation('getDocumentCookie');
            const amaznAppContextCookieValue = this.o.amznAppContext ? `amzn-app-ctxt=${this.o.amznAppContext}` : undefined;
            return amaznAppContextCookieValue !== null && amaznAppContextCookieValue !== void 0 ? amaznAppContextCookieValue : '';
        };
        /**
         * TODO: deprecate this and replace it with shouldHaveAutoplayPermissionFromDevice
         * https://sim.amazon.com/issues/CPP-30396
         */ this.getUserConnectionInfo = ()=>{
            this.logAPIInvocation('getUserConnectionInfo');
            return (0, $53704daf19feb304$export$c322d029f938aae3)(this.o.amznAppContext);
        };
        this.mash = new (0, $b992f02665ee6647$export$ae62af5864067f17)(this, cms, o);
    }
}



class $89f0a9545dddff79$export$36a910dd0f146126 {
    constructor(o, messagePort){
        this.o = o;
        this.messagePort = messagePort;
        this.sendMessage = (command, data)=>{
            const msg = {
                command: command,
                adDetails: this.o,
                payload: data || {}
            };
            try {
                this.messagePort.postMessage(msg);
            } catch (ex) {
                (0, $b3a71d4461d0cfe8$export$e4adf93fa9694f6)('Post Message error', ex);
            }
        };
    }
}


class $0c988b6e6817f132$export$e9b3bf4aca953d8c {
    constructor(c, o, mL){
        this.c = c;
        this.o = o;
        this.mL = mL;
        this.pendingMessages = new Map();
        // TODO Convert this to a more generalized mechanism
        // For now it just waits for the next message of the key to be processed
        // Main usecase is for dynamic compuated details to get the non-Promised APIS to work as in
        // https://code.amazon.com/packages/SafeFrameClient/blobs/e6d7afa4b0c567ab7ba245a07efd974cd8f3a6b6/--/packages/safe-frame-client-mobilesfclient/src/MobileSFClientAPI.ts#L187
        /**
         * This does not support more than one wait per message time and promise will only be resolved once
         * @deprecated
         * @param key The commadn to for wait for
         * @returns A promise that will be fired.
         */ this.waitForMessageProcessed = async (key)=>{
            return new Promise((resolve)=>this.pendingMessages.set(key, resolve));
        };
        this.receiveMessage = (event)=>{
            try {
                const msg = event.data;
                // msgObj is expected to have a command
                const cmdPath = msg.command ? msg.command.split('.') : [];
                let action = this.c[cmdPath[0]];
                for(let i = 1; i < cmdPath.length; i++){
                    if (action) action = action[cmdPath[i]];
                    else break;
                }
                if (msg.command === 'customMessage') {
                    // treat custom message specially
                    const msgKey = msg.data.key;
                    const body = msg.data.data;
                    if (typeof this.mL[msgKey] === 'function') try {
                        this.mL[msgKey](body);
                    } catch (ex) {
                        this.c.logError('Custom Message Listener Error', ex);
                    }
                } else if (action) {
                    action(msg.data);
                    $0c988b6e6817f132$var$resolveMessagePromise(msg.command, this.pendingMessages);
                }
            } catch (ex) {
                //Log the error metrics for debugging purposes.
                this.c.logError('Error with ' + event.data.command, ex);
                return;
            }
        };
    }
}
const $0c988b6e6817f132$var$resolveMessagePromise = (command, pendingMessages)=>{
    const resolve = pendingMessages === null || pendingMessages === void 0 ? void 0 : pendingMessages.get(command);
    resolve === null || resolve === void 0 ? void 0 : resolve();
    pendingMessages === null || pendingMessages === void 0 ? void 0 : pendingMessages.delete(command);
};



class $ba67238d792ee7be$export$cfb53b71024594c6 extends (0, $28e094dd001dcab4$export$26e23c7200e8a435) {
    constructor(cms, o, mL){
        super(cms, o, mL);
        this.isSupported = ()=>{
            // TODO Remove in the public API
            return true;
        };
        this.getARID = ()=>{
            return this.o.arid;
        };
        this.sendAdInfo = (adInfo)=>{
            if (adInfo && this.o.adCreativeMetaData) this.o.adCreativeMetaData = adInfo;
        };
        this.getPlacementInfo = ()=>{
            this.logAPIInvocation('getPlacementInfo');
            return {
                slot: this.o.placementName,
                slotName: this.o.slotName,
                pageType: this.o.pageType
            };
        };
    }
}



const $bf321b6719b226e7$export$f8787fad5afc2773 = (mp)=>{
    return {
        onSafeFrameReady: (adDetails)=>$bf321b6719b226e7$var$sendMessage(mp, 'onSafeFrameReady', adDetails),
        onPreCreativeWrite: (adDetails)=>$bf321b6719b226e7$var$sendMessage(mp, 'onPreCreativeWrite', adDetails),
        onPostCreativeWrite: (adDetails)=>$bf321b6719b226e7$var$sendMessage(mp, 'onPostCreativeWrite', adDetails),
        onCreativeBeginToRender: (adDetails)=>$bf321b6719b226e7$var$sendMessage(mp, 'onCreativeBeginToRender', adDetails),
        onCreativeLoad: (adDetails)=>$bf321b6719b226e7$var$sendMessage(mp, 'onCreativeLoad', adDetails),
        onError: (adDetails)=>$bf321b6719b226e7$var$sendMessage(mp, 'onError', adDetails),
        onClick: (adDetails)=>$bf321b6719b226e7$var$sendMessage(mp, 'onClick', adDetails)
    };
};
const $bf321b6719b226e7$var$sendMessage = (messagePort, command, adDetails)=>{
    const msg = {
        command: command,
        adDetails: adDetails,
        payload: {}
    };
    try {
        messagePort.postMessage(msg);
    } catch (ex) {
        (0, $b3a71d4461d0cfe8$export$e4adf93fa9694f6)('Post Message error', ex);
    }
};


const $8fe6e56f6b3214b3$export$1a0ed9edc6ef60a2 = (adDetails, messagePort)=>{
    const cms = new (0, $89f0a9545dddff79$export$36a910dd0f146126)(adDetails, messagePort);
    const mL = {};
    const clientAPI = new (0, $9b1bc92cd0529901$export$8b15f44b658c097f)(cms, adDetails, mL);
    const cmr = new (0, $0c988b6e6817f132$export$e9b3bf4aca953d8c)(clientAPI, adDetails, mL);
    const eventsChannel = (0, $bf321b6719b226e7$export$f8787fad5afc2773)(messagePort);
    return new (0, $4a3b13a78cd2b2bf$export$3506e262fca74394)(adDetails, messagePort, cms, cmr, clientAPI, eventsChannel);
};
const $8fe6e56f6b3214b3$export$6905ed309eea380b = (adDetails, messagePort)=>{
    const cms = new (0, $89f0a9545dddff79$export$36a910dd0f146126)(adDetails, messagePort);
    const mL = {};
    const clientAPI = new (0, $ba67238d792ee7be$export$cfb53b71024594c6)(cms, adDetails, mL);
    const cmr = new (0, $0c988b6e6817f132$export$e9b3bf4aca953d8c)(clientAPI, adDetails, mL);
    const eventsChannel = (0, $bf321b6719b226e7$export$f8787fad5afc2773)(messagePort);
    return new (0, $4a3b13a78cd2b2bf$export$3506e262fca74394)(adDetails, messagePort, cms, cmr, clientAPI, eventsChannel);
};


const $63b18199cf60cfeb$export$3c2ba21628313539 = (safeFrameClientFactory)=>{
    // TODO: clean up referrer check once https://sim.amazon.com/issues/CPP-41009 is solved
    if (window.origin !== 'null' && !(0, $278476fd5b62a476$export$3338c8be5e6eacef)()) {
        (0, $b57dd1b6deb577cc$export$278222a831e222e9)(`Referrer not allowed: ${document.referrer}`);
        return;
    }
    const adDetails = $63b18199cf60cfeb$var$getAdDetailsFromIFrameName();
    if (adDetails) {
        const mc = new MessageChannel();
        $63b18199cf60cfeb$var$init(safeFrameClientFactory, mc.port1, adDetails);
        $63b18199cf60cfeb$var$notifyParentWithMessagePort(mc.port2);
    } else (0, $b57dd1b6deb577cc$export$58da9968c3170cb1)('Ad Details not found in name!');
};
const $63b18199cf60cfeb$var$init = async (safeFrameClientFactory, messagePort, iframeNameAdDetails)=>{
    try {
        var _performance_mark, _performance;
        (0, $1da12facc0a277d6$export$5416796335c2f54c)();
        const adDetails = iframeNameAdDetails;
        var _adDetails_weblabTreatments;
        // FIX ME: we should not have a stringified obj inside the stringified AdDetails. Fix this upstream
        window.renderingWeblabs = JSON.parse((_adDetails_weblabTreatments = adDetails.weblabTreatments) !== null && _adDetails_weblabTreatments !== void 0 ? _adDetails_weblabTreatments : '');
        (_performance = performance) === null || _performance === void 0 ? void 0 : (_performance_mark = _performance.mark) === null || _performance_mark === void 0 ? void 0 : _performance_mark.call(_performance, 'SafeFrame: SF received ad details');
        const safeFrameClient = safeFrameClientFactory(messagePort, adDetails);
        try {
            safeFrameClient.initSFClient();
        } catch (ex) {
            safeFrameClient.c.logError('Could not init SafeFrame Client', ex);
        }
    } catch (ex) {
        (0, $b3a71d4461d0cfe8$export$e4adf93fa9694f6)('Could not init ', ex);
    }
};
const $63b18199cf60cfeb$export$5c26b0cb1f9bd93c = (messagePort, adDetails)=>{
    const sfClient = (0, $8fe6e56f6b3214b3$export$6905ed309eea380b)(adDetails, messagePort);
    window.SFClient = sfClient.c;
    return sfClient;
};
const $63b18199cf60cfeb$export$59d3b6a61c21b6b7 = (messagePort, adDetails)=>{
    const msfClient = (0, $8fe6e56f6b3214b3$export$1a0ed9edc6ef60a2)(adDetails, messagePort);
    window.MSFClient = msfClient.c;
    return msfClient;
};
// We use this to notify the parent the frame is ready to accept messages
// Previously we used onload but this doesn't always find due to hidden
// e.g. https://stackoverflow.com/questions/12410606/hidden-iframe-onload-event
const $63b18199cf60cfeb$var$notifyParentWithMessagePort = (mp)=>{
    var _performance_mark, _performance;
    (_performance = performance) === null || _performance === void 0 ? void 0 : (_performance_mark = _performance.mark) === null || _performance_mark === void 0 ? void 0 : _performance_mark.call(_performance, `SafeFrame: Start Send Ready ${mp}`);
    // Use this to work around https://github.com/jsdom/jsdom/issues/2745
    try {
        // This will fail in the normal browser but work in JSDOM
        window.parent.dispatchEvent(new MessageEvent('message', {
            source: window,
            origin: window.location.origin,
            ports: [
                mp
            ],
            data: (0, $cdfa235a5a79407b$export$ff1e03425229fa2c)
        }));
    } catch (e) {
        window.parent.postMessage((0, $cdfa235a5a79407b$export$ff1e03425229fa2c), '*', [
            mp
        ]);
    }
};
const $63b18199cf60cfeb$var$getAdDetailsFromIFrameName = ()=>{
    return window.name !== '' ? JSON.parse(window.name) : null;
};


var $4cce9f3a9fa660d8$var$_performance_mark, $4cce9f3a9fa660d8$var$_performance;
($4cce9f3a9fa660d8$var$_performance = performance) === null || $4cce9f3a9fa660d8$var$_performance === void 0 ? void 0 : ($4cce9f3a9fa660d8$var$_performance_mark = $4cce9f3a9fa660d8$var$_performance.mark) === null || $4cce9f3a9fa660d8$var$_performance_mark === void 0 ? void 0 : $4cce9f3a9fa660d8$var$_performance_mark.call($4cce9f3a9fa660d8$var$_performance, 'SafeFrame: Enter sf.ts');
if (!window.SFClient) (0, $63b18199cf60cfeb$export$3c2ba21628313539)((0, $63b18199cf60cfeb$export$5c26b0cb1f9bd93c));


//# sourceMappingURL=sf-1.50.d8809683.js.map
